!(function (e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define([], e)
    : (("undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : this
      ).basicLightbox = e());
})(function () {
  return (function e(t, i, s) {
    function r(o, a) {
      if (!i[o]) {
        if (!t[o]) {
          var l = "function" == typeof require && require;
          if (!a && l) return l(o, !0);
          if (n) return n(o, !0);
          var c = new Error("Cannot find module '" + o + "'");
          throw ((c.code = "MODULE_NOT_FOUND"), c);
        }
        var d = (i[o] = { exports: {} });
        t[o][0].call(
          d.exports,
          function (e) {
            return r(t[o][1][e] || e);
          },
          d,
          d.exports,
          e,
          t,
          i,
          s
        );
      }
      return i[o].exports;
    }
    for (
      var n = "function" == typeof require && require, o = 0;
      o < s.length;
      o++
    )
      r(s[o]);
    return r;
  })(
    {
      1: [
        function (e, t, i) {
          "use strict";
          Object.defineProperty(i, "__esModule", { value: !0 }),
            (i.create = i.visible = void 0);
          var s = function (e) {
              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                i = document.createElement("div");
              return (
                (i.innerHTML = e.trim()), !0 === t ? i.children : i.firstChild
              );
            },
            r = function (e, t) {
              var i = e.children;
              return 1 === i.length && i[0].tagName === t;
            },
            n = function (e) {
              return (
                null != (e = e || document.querySelector(".basicLightbox")) &&
                !0 === e.ownerDocument.body.contains(e)
              );
            };
          (i.visible = n),
            (i.create = function (e, t) {
              var i = (function (e, t) {
                  var i = s(
                      '\n\t\t<div class="basicLightbox '.concat(
                        t.className,
                        '">\n\t\t\t<div class="basicLightbox__placeholder" role="dialog"></div>\n\t\t</div>\n\t'
                      )
                    ),
                    n = i.querySelector(".basicLightbox__placeholder");
                  e.forEach(function (e) {
                    return n.appendChild(e);
                  });
                  var o = r(n, "IMG"),
                    a = r(n, "VIDEO"),
                    l = r(n, "IFRAME");
                  return (
                    !0 === o && i.classList.add("basicLightbox--img"),
                    !0 === a && i.classList.add("basicLightbox--video"),
                    !0 === l && i.classList.add("basicLightbox--iframe"),
                    i
                  );
                })(
                  (e = (function (e) {
                    var t = "string" == typeof e,
                      i = e instanceof HTMLElement == 1;
                    if (!1 === t && !1 === i)
                      throw new Error(
                        "Content must be a DOM element/node or string"
                      );
                    return !0 === t
                      ? Array.from(s(e, !0))
                      : "TEMPLATE" === e.tagName
                      ? [e.content.cloneNode(!0)]
                      : Array.from(e.children);
                  })(e)),
                  (t = (function () {
                    var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    if (
                      (null == (e = Object.assign({}, e)).closable &&
                        (e.closable = !0),
                      null == e.className && (e.className = ""),
                      null == e.onShow && (e.onShow = function () {}),
                      null == e.onClose && (e.onClose = function () {}),
                      "boolean" != typeof e.closable)
                    )
                      throw new Error("Property `closable` must be a boolean");
                    if ("string" != typeof e.className)
                      throw new Error("Property `className` must be a string");
                    if ("function" != typeof e.onShow)
                      throw new Error("Property `onShow` must be a function");
                    if ("function" != typeof e.onClose)
                      throw new Error("Property `onClose` must be a function");
                    return e;
                  })(t))
                ),
                o = function (e) {
                  return (
                    !1 !== t.onClose(a) &&
                    (function (e, t) {
                      return (
                        e.classList.remove("basicLightbox--visible"),
                        setTimeout(function () {
                          return (
                            !1 === n(e) || e.parentElement.removeChild(e), t()
                          );
                        }, 410),
                        !0
                      );
                    })(i, function () {
                      if ("function" == typeof e) return e(a);
                    })
                  );
                };
              !0 === t.closable &&
                i.addEventListener("click", function (e) {
                  e.target === i && o();
                });
              var a = {
                element: function () {
                  return i;
                },
                visible: function () {
                  return n(i);
                },
                show: function (e) {
                  return (
                    !1 !== t.onShow(a) &&
                    (function (e, t) {
                      return (
                        document.body.appendChild(e),
                        setTimeout(function () {
                          requestAnimationFrame(function () {
                            return (
                              e.classList.add("basicLightbox--visible"), t()
                            );
                          });
                        }, 10),
                        !0
                      );
                    })(i, function () {
                      if ("function" == typeof e) return e(a);
                    })
                  );
                },
                close: o,
              };
              return a;
            });
        },
        {},
      ],
    },
    {},
    [1]
  )(1);
}),
  (function () {
    "use strict";
    function e() {
      var e = window,
        t = document;
      if (
        !("scrollBehavior" in t.documentElement.style) ||
        !0 === e.__forceSmoothScrollPolyfill__
      ) {
        var i,
          s = e.HTMLElement || e.Element,
          r = 468,
          n = {
            scroll: e.scroll || e.scrollTo,
            scrollBy: e.scrollBy,
            elementScroll: s.prototype.scroll || l,
            scrollIntoView: s.prototype.scrollIntoView,
          },
          o =
            e.performance && e.performance.now
              ? e.performance.now.bind(e.performance)
              : Date.now,
          a =
            ((i = e.navigator.userAgent),
            new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(i)
              ? 1
              : 0);
        (e.scroll = e.scrollTo =
          function () {
            void 0 !== arguments[0] &&
              (!0 !== c(arguments[0])
                ? p.call(
                    e,
                    t.body,
                    void 0 !== arguments[0].left
                      ? ~~arguments[0].left
                      : e.scrollX || e.pageXOffset,
                    void 0 !== arguments[0].top
                      ? ~~arguments[0].top
                      : e.scrollY || e.pageYOffset
                  )
                : n.scroll.call(
                    e,
                    void 0 !== arguments[0].left
                      ? arguments[0].left
                      : "object" != typeof arguments[0]
                      ? arguments[0]
                      : e.scrollX || e.pageXOffset,
                    void 0 !== arguments[0].top
                      ? arguments[0].top
                      : void 0 !== arguments[1]
                      ? arguments[1]
                      : e.scrollY || e.pageYOffset
                  ));
          }),
          (e.scrollBy = function () {
            void 0 !== arguments[0] &&
              (c(arguments[0])
                ? n.scrollBy.call(
                    e,
                    void 0 !== arguments[0].left
                      ? arguments[0].left
                      : "object" != typeof arguments[0]
                      ? arguments[0]
                      : 0,
                    void 0 !== arguments[0].top
                      ? arguments[0].top
                      : void 0 !== arguments[1]
                      ? arguments[1]
                      : 0
                  )
                : p.call(
                    e,
                    t.body,
                    ~~arguments[0].left + (e.scrollX || e.pageXOffset),
                    ~~arguments[0].top + (e.scrollY || e.pageYOffset)
                  ));
          }),
          (s.prototype.scroll = s.prototype.scrollTo =
            function () {
              if (void 0 !== arguments[0])
                if (!0 !== c(arguments[0])) {
                  var e = arguments[0].left,
                    t = arguments[0].top;
                  p.call(
                    this,
                    this,
                    void 0 === e ? this.scrollLeft : ~~e,
                    void 0 === t ? this.scrollTop : ~~t
                  );
                } else {
                  if (
                    "number" == typeof arguments[0] &&
                    void 0 === arguments[1]
                  )
                    throw new SyntaxError("Value could not be converted");
                  n.elementScroll.call(
                    this,
                    void 0 !== arguments[0].left
                      ? ~~arguments[0].left
                      : "object" != typeof arguments[0]
                      ? ~~arguments[0]
                      : this.scrollLeft,
                    void 0 !== arguments[0].top
                      ? ~~arguments[0].top
                      : void 0 !== arguments[1]
                      ? ~~arguments[1]
                      : this.scrollTop
                  );
                }
            }),
          (s.prototype.scrollBy = function () {
            void 0 !== arguments[0] &&
              (!0 !== c(arguments[0])
                ? this.scroll({
                    left: ~~arguments[0].left + this.scrollLeft,
                    top: ~~arguments[0].top + this.scrollTop,
                    behavior: arguments[0].behavior,
                  })
                : n.elementScroll.call(
                    this,
                    void 0 !== arguments[0].left
                      ? ~~arguments[0].left + this.scrollLeft
                      : ~~arguments[0] + this.scrollLeft,
                    void 0 !== arguments[0].top
                      ? ~~arguments[0].top + this.scrollTop
                      : ~~arguments[1] + this.scrollTop
                  ));
          }),
          (s.prototype.scrollIntoView = function () {
            if (!0 !== c(arguments[0])) {
              var i = (function (e) {
                  for (
                    ;
                    e !== t.body &&
                    !1 ===
                      ((s = d((i = e), "Y") && h(i, "Y")),
                      (r = d(i, "X") && h(i, "X")),
                      s || r);

                  )
                    e = e.parentNode || e.host;
                  var i, s, r;
                  return e;
                })(this),
                s = i.getBoundingClientRect(),
                r = this.getBoundingClientRect();
              i !== t.body
                ? (p.call(
                    this,
                    i,
                    i.scrollLeft + r.left - s.left,
                    i.scrollTop + r.top - s.top
                  ),
                  "fixed" !== e.getComputedStyle(i).position &&
                    e.scrollBy({
                      left: s.left,
                      top: s.top,
                      behavior: "smooth",
                    }))
                : e.scrollBy({ left: r.left, top: r.top, behavior: "smooth" });
            } else
              n.scrollIntoView.call(
                this,
                void 0 === arguments[0] || arguments[0]
              );
          });
      }
      function l(e, t) {
        (this.scrollLeft = e), (this.scrollTop = t);
      }
      function c(e) {
        if (
          null === e ||
          "object" != typeof e ||
          void 0 === e.behavior ||
          "auto" === e.behavior ||
          "instant" === e.behavior
        )
          return !0;
        if ("object" == typeof e && "smooth" === e.behavior) return !1;
        throw new TypeError(
          "behavior member of ScrollOptions " +
            e.behavior +
            " is not a valid value for enumeration ScrollBehavior."
        );
      }
      function d(e, t) {
        return "Y" === t
          ? e.clientHeight + a < e.scrollHeight
          : "X" === t
          ? e.clientWidth + a < e.scrollWidth
          : void 0;
      }
      function h(t, i) {
        var s = e.getComputedStyle(t, null)["overflow" + i];
        return "auto" === s || "scroll" === s;
      }
      function u(t) {
        var i,
          s,
          n,
          a,
          l = (o() - t.startTime) / r;
        (a = l = l > 1 ? 1 : l),
          (i = 0.5 * (1 - Math.cos(Math.PI * a))),
          (s = t.startX + (t.x - t.startX) * i),
          (n = t.startY + (t.y - t.startY) * i),
          t.method.call(t.scrollable, s, n),
          (s === t.x && n === t.y) || e.requestAnimationFrame(u.bind(e, t));
      }
      function p(i, s, r) {
        var a,
          c,
          d,
          h,
          p = o();
        i === t.body
          ? ((a = e),
            (c = e.scrollX || e.pageXOffset),
            (d = e.scrollY || e.pageYOffset),
            (h = n.scroll))
          : ((a = i), (c = i.scrollLeft), (d = i.scrollTop), (h = l)),
          u({
            scrollable: a,
            method: h,
            startTime: p,
            startX: c,
            startY: d,
            x: s,
            y: r,
          });
      }
    }
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = { polyfill: e })
      : e();
  })();
class AnnouncementBar extends HTMLElement {
  constructor() {
    super(),
      document.querySelector(".announcement__exit") &&
        document
          .querySelector(".announcement__exit")
          .addEventListener("click", () => {
            document.body.classList.add("no-transition"),
              setTimeout(() => {
                document.body.classList.remove("show-announcement-bar"),
                  localStorage.setItem("announcement-dismissed", "true"),
                  setTimeout(() => {
                    document.body.classList.remove("no-transitions");
                  }, 100);
              }, 10);
          });
  }
}
customElements.define("announcement-bar", AnnouncementBar);
const toggleAnnouncement = (e) => {
  e.target.classList.contains("mount-announcement") &&
    (document.querySelector(".announcement")
      ? document.body.classList.add("show-announcement-bar")
      : document.body.classList.remove("show-announcement-bar"));
};
document.addEventListener("shopify:section:load", toggleAnnouncement),
  document.addEventListener("shopify:section:select", toggleAnnouncement);
class CartForm extends HTMLElement {
  constructor() {
    super(), this.ajaxifyCartItems();
  }
  ajaxifyCartItems() {
    (this.form = this.querySelector("form")),
      this.querySelectorAll(".cart-item").forEach((e) => {
        const t = e.querySelector(".remove1");
        t &&
          ((t.dataset.href = t.getAttribute("href")),
          t.setAttribute("href", ""),
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.updateCartQty(e, 0);
          }));
        const i = e.querySelector(".qty");
        i &&
          (i.addEventListener(
            "input",
            debounce((t) => {
              t.preventDefault(),
                t.target.blur(),
                this.updateCartQty(e, parseInt(i.value));
            }, 300)
          ),
          i.addEventListener("click", (e) => {
            e.target.select();
          }));
      });
  }
  updateCartQty(e, t) {
    this.form.classList.add("processing"),
      this.querySelector(".alert") && this.querySelector(".alert").remove();
    const i = JSON.stringify({ id: e.dataset.id, quantity: t });
    fetch(KROWN.settings.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
      },
      body: i,
    })
      .then((e) => {
        if (e.ok) return fetch("?section_id=cart-helper");
        throw new Error("Something went wrong");
      })
      .then((e) => e.text())
      .then((i) => {
        const s = new DOMParser().parseFromString(i, "text/html"),
          r = s.getElementById("AjaxCartForm").innerHTML,
          n = s.getElementById("AjaxCartSubtotal").innerHTML,
          o = document.getElementById("AjaxCartForm");
        if (
          ((o.innerHTML = r),
          o.ajaxifyCartItems(),
          (document.querySelector("[data-header-cart-count]").textContent =
            o.querySelector("[data-cart-count]").textContent),
          0 != t &&
            t >
              parseInt(
                o.querySelector(`.cart-item[data-id="${e.dataset.id}"]`).dataset
                  .qty
              ))
        ) {
          let t = document.createElement("span");
          t.classList.add("alert", "alert--error"),
            (t.textContent = KROWN.settings.locales.cart_add_error.replace(
              "{{ title }}",
              e.dataset.title
            )),
            this.form.prepend(t);
        }
        (document.getElementById("AjaxCartSubtotal").innerHTML = n),
          window.preloadImages(o);
      })
      .catch((e) => {
        console.log(e);
        let t = document.createElement("span");
        t.classList.add("alert", "alert--error"),
          (t.textContent = KROWN.settings.locales.cart_general_error),
          this.form.prepend(t);
      })
      .finally(() => {
        this.form.classList.remove("processing");
      });
  }
}
customElements.define("cart-form", CartForm);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.filterData = []),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500)),
      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      ),
      this.classList.contains("don-t-duplicate") ||
        ((document.getElementById("FacetFiltersFormMobile").innerHTML =
          document.getElementById("FacetFiltersForm").innerHTML),
        document
          .getElementById("FacetFiltersFormMobile")
          .addEventListener("input", this.debouncedOnSubmit.bind(this)),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelectorAll(".facets__item")
          .forEach((e) => {
            const t = e.querySelector("input").id;
            e.querySelector("label").setAttribute("for", `mobile-${t}`),
              (e.querySelector("input").id = `mobile-${t}`);
          }),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.remove("active-facets-desktop"),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.add("active-facets-mobile"));
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, i = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const s = FacetFiltersForm.getSections();
    document
      .getElementById("main-collection-product-grid")
      .classList.add("loading"),
      s.forEach((i) => {
        const s = `${window.location.pathname}?section_id=${i.section}&${e}`,
          r = (e) => e.url === s;
        FacetFiltersForm.filterData.some(r)
          ? FacetFiltersForm.renderSectionFromCache(r, t)
          : FacetFiltersForm.renderSectionFromFetch(s, t);
      }),
      i && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((i) => {
        const s = i;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: s, url: e },
        ]),
          FacetFiltersForm.renderFilters(s, t),
          FacetFiltersForm.renderProductGrid(s),
          FacetFiltersForm.renderProductCount(s);
      });
  }
  static renderSectionFromCache(e, t) {
    const i = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(i, t),
      FacetFiltersForm.renderProductGrid(i),
      FacetFiltersForm.renderProductCount(i);
  }
  static renderProductGrid(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductGrid").innerHTML;
    (document.getElementById("CollectionProductGrid").innerHTML = t),
      window.preloadImages(document.getElementById("CollectionProductGrid"));
  }
  static renderProductCount(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductCount");
    t &&
      (document.getElementById("CollectionProductCount").innerHTML =
        t.innerHTML);
  }
  static renderFilters(e, t) {
    const i = new DOMParser().parseFromString(e, "text/html"),
      s = i.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
      ),
      r = (e) => {
        if (t && t.target.closest(".js-filter"))
          return (
            e.dataset.index === t.target.closest(".js-filter").dataset.index
          );
      },
      n = Array.from(s).filter((e) => !r(e)),
      o = Array.from(s).find(r);
    n.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(i),
      o && FacetFiltersForm.renderCounts(o, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const i = e.querySelector(".active-facets");
      i &&
        document.querySelector(t) &&
        (document.querySelector(t).innerHTML = i.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderCounts(e, t) {
    [".facets__selected"].forEach((i) => {
      const s = t.querySelector(i);
      e.querySelector(i) &&
        s &&
        (t.querySelector(i).outerHTML = e.querySelector(i).outerHTML);
    });
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [
      {
        id: "main-collection-product-grid",
        section: document.getElementById("main-collection-product-grid").dataset
          .id,
      },
    ];
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const t = new FormData(e.target.closest("form")),
      i = new URLSearchParams(t).toString();
    FacetFiltersForm.renderPage(i, e);
  }
  onActiveFilterClick(e) {
    e.preventDefault(),
      FacetFiltersForm.toggleActiveFacets(),
      FacetFiltersForm.renderPage(
        new URL(e.currentTarget.href).searchParams.toString()
      );
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        (
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form")
        ).onActiveFilterClick(e);
      });
  }
}
customElements.define("facet-remove", FacetRemove);
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll("input"),
      t = e[0],
      i = e[1];
    i.value && t.setAttribute("max", i.value),
      t.value && i.setAttribute("min", t.value),
      "" === t.value && i.setAttribute("min", 0),
      "" === i.value && t.setAttribute("max", i.getAttribute("max"));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      i = Number(e.getAttribute("min")),
      s = Number(e.getAttribute("max"));
    t < i && (e.value = i), t > s && (e.value = s);
  }
}
customElements.define("price-range", PriceRange);
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.selector = this.querySelector(".regular-select-cover")),
      (this.content = this.querySelector(".regular-select-content")),
      this.selector.addEventListener("click", (e) => {
        e.stopPropagation(),
          e.preventDefault(),
          document
            .querySelectorAll(".regular-select-cover.content-opened")
            .forEach((t) => {
              t != e.currentTarget &&
                (t.classList.remove("content-opened"),
                (t.parentNode.style.zIndex = 9));
            }),
          this.content.classList.contains("content-opened")
            ? (e.currentTarget.setAttribute("aria-expanded", "false"),
              (this.content.parentNode.style.zIndex = 9),
              this.content.classList.remove("content-opened", "invert"),
              window.removeEventListener("click", this.onClickHandler))
            : (this.content.classList.add("content-opened"),
              e.currentTarget.setAttribute("aria-expanded", "true"),
              (this.content.parentNode.style.zIndex = 1e3),
              this.content.classList.contains("invert-with-fixed")
                ? this.content.getBoundingClientRect().y +
                    this.content.outerHeight +
                    55 >
                    window.innerHeight && this.content.classList.add("invert")
                : this.content.offsetTop + this.content.outerHeight + 55 >
                    document.querySelector("html").outerHeight &&
                  this.content.classList.add("invert"),
              (this.onClickHandler = (() => {
                this.content.classList.contains("content-opened") &&
                  (this.content.classList.remove("content-opened", "invert"),
                  (this.content.parentNode.style.zIndex = 9));
              }).bind(this)),
              window.addEventListener("click", this.onClickHandler));
      }),
      this.querySelector(".regular-select-cover").addEventListener(
        "keydown",
        function (e) {
          e.keyCode == window.KEYCODES.RETURN &&
            (this.content.classList.contains("opened-with-tab") ||
              (this.content.classList.add("opened-with-tab"),
              this.content
                .querySelectorAll(".regular-select-item")
                .forEach((e) => {
                  e.setAttribute("tabindex", "0");
                })));
        }
      );
  }
}
customElements.define("localization-form", LocalizationForm);
class ModalBox extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.o = {
        show: 10,
        frequency: "day",
        enabled: !0,
        ...JSON.parse(this.dataset.options),
      }),
      (this._modalKey = `modal-${document.location.hostname}-${this.id}`),
      (this._modalStorage = localStorage.getItem(this._modalKey)
        ? JSON.parse(localStorage.getItem(this._modalKey))
        : "empty"),
      (this._modalText = this.extractText(
        this.querySelector("[data-content]")
      )),
      this.o.enabled)
    ) {
      const e = new Date().getTime(),
        t = Math.round((e - this._modalStorage.shown) / 1e3);
      let i = !1;
      ("empty" == this._modalStorage ||
        ("day" == this.frequency && t > 86400) ||
        ("week" == this.frequency && t > 604800) ||
        ("month" == this.frequency && t > 2419200) ||
        this._modalStorage.content != this._modalText) &&
        (i = !0),
        i &&
          (setTimeout(() => {
            this.show();
          }, parseInt(1e3 * this.o.show)),
          setTimeout(() => {
            this.querySelectorAll("[data-close]").forEach((e) =>
              e.addEventListener("click", () => {
                this.hide(!0);
              })
            );
          }, 100));
    }
    this.setAttribute("style", "");
  }
  show() {
    window.preloadImages(this), this.classList.add("active");
  }
  hide(e = !1) {
    this.classList.remove("active"),
      e &&
        !Shopify.designMode &&
        localStorage.setItem(
          this._modalKey,
          JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText,
          })
        );
  }
  extractText(e) {
    let t = document.createElement("span");
    t.innerHTML = e.innerHTML;
    const i = t.textContent || t.innerText;
    return t.remove(), [i].toString().replace(/ +/g, "");
  }
}
customElements.define("modal-box", ModalBox),
  document.addEventListener("shopify:section:select", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").show();
  }),
  document.addEventListener("shopify:section:deselect", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").hide();
  });
class ProductVariants extends HTMLElement {
  constructor() {
    super(),
      (this.price = document.querySelector(
        `#product-price-${this.dataset.id}`
      )),
      this.price &&
        ((this.priceOriginal = this.price.querySelector(
          ".product__price--original"
        )),
        (this.priceCompare = this.price.querySelector(
          ".product__price--compare"
        )),
        (this.priceUnit = this.price.querySelector(".product__price--unit"))),
      (this.productForm = document.querySelector(
        `#product-form-${this.dataset.id}`
      )),
      this.productForm &&
        ((this.productQty = this.productForm.querySelector(".product__quantity")),
        (this.addToCart = this.productForm.querySelector(".product__add-to-cart")),
        (this.addToCartText = this.productForm.querySelector(".add-to-cart__text")),
        (this.notify_me = this.productForm.querySelector(
          ".product-notify_me-button"
        )),
        (this.pre_order = this.productForm.querySelector(
          ".product-pre-order-button"
        ))),
      (this.productSKU = document.querySelector(
        `#product-${this.dataset.id} .product__sku`
      )),
      (this.productBARCODE = document.querySelector(
        `#product-${this.dataset.id} .product__barcode`
      )),
      this.addEventListener("change", this.onVariantChange),
      this.updateOptions(),
      this.updateMasterId(),
      (this.productStock = this.querySelector(".variant-quantity")),
      this.productStock &&
        this.querySelector(".variant-quantity-data") &&
        (this.productStockData = JSON.parse(
          this.querySelector(".variant-quantity-data").dataset.inventory
        )),
      this.updateStock(),
      (this._event = new Event("VARIANT_CHANGE"));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.updateVariantInput(),
      this.price && this.updatePrice(),
      this.updateStock(),
      this.updatePickupAvailability(),
      this.hasAttribute("data-no-history") || this.updateURL(),
      this.updateDetails(),
      (this.dpoAddToCart = this.productForm.querySelector(".product__add-to-cart[dpo_add2cart]") || this.addToCart),
      (this.dpoAddToCartText = this.dpoAddToCart.querySelector(".add-to-cart__text")),
      this.productForm &&
        document.querySelector(".product__cart-actions-holder") &&
        (this.currentVariant && this.currentVariant.available
          ? (this.productQty && (this.productQty.style.display = ""),
            console.log(this.addToCart, '===== this.addToCart', this.dpoAddToCart),
            this.addToCart.classList.remove("disabled"),
            this.dpoAddToCart.classList.remove("disabled"),
            this.productForm.classList.remove("disabled-cart"),
            (this.addToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button),
            (this.dpoAddToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button),
            (this.notify_me.style.display = "none"),
            document.querySelector(".shopify-payment-button") &&
            (document.querySelector(".shopify-payment-button").style.display = "block"),
            (document.querySelector(".product__cart-actions-holder").style.display = "inline-flex"), 
            (document.querySelector(".product__quantity").style.display = "block"), 
            $(".product__cart-actions-holder .product__add-to-cart").removeClass("no-cart"))
          : (this.productQty && (this.productQty.style.display = "none"),
            this.addToCart.classList.add("disabled"),
            this.dpoAddToCart.classList.add("disabled"),
            this.productForm.classList.add("disabled-cart"),
            (this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant),
            (this.dpoAddToCartText.textContent = KROWN.settings.locales.products_sold_out_variant),
            (this.notify_me.style.display = "inline-flex"),
            document.querySelector(".shopify-payment-button") &&
            (document.querySelector(".shopify-payment-button").style.display = "none"),
            (document.querySelector(".product__cart-actions-holder").style.display = "none"), 
            (document.querySelector(".product__quantity").style.display = "none")),
        this.currentVariant
          ? this.productForm.classList.remove("unavailable-variant")
          : (this.productForm.classList.add("unavailable-variant"),
            (this.addToCartText.textContent = KROWN.settings.locales.products_unavailable_variant),
            (this.dpoAddToCartText.textContent = KROWN.settings.locales.products_unavailable_variant),
            (this.notify_me.style.display = "none"),
            (document.querySelector(".product__cart-actions-holder").style.display = "inline-flex"), 
            (document.querySelector(".product__quantity").style.display = "block"),
            $(".product__cart-actions-holder .product__add-to-cart").addClass("no-cart"),
            document.querySelector(".shopify-payment-button") &&
            (document.querySelector(".shopify-payment-button").style.display = "block"))),
      this.dispatchEvent(this._event);
      console.log(this.addToCartText, '3434535435', this.dpoAddToCart, this.dpoAddToCartText, '------------------');
  }
  updateOptions() {
    "select" == this.dataset.type
      ? (this.options = Array.from(
          this.querySelectorAll(".product-variant-container"),
          (e) => e.value
        ))
      : "radio" == this.dataset.type &&
        ((this.options = []),
        this.querySelectorAll(".product-variant__input").forEach((e) => {
          e.checked && this.options.push(e.value);
        }));
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updatePrice() {
    this.currentVariant
      ? ((this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(
          this.currentVariant.price,
          KROWN.settings.shop_money_format
        )),
        this.currentVariant.compare_at_price > this.currentVariant.price
          ? ((this.priceCompare.innerHTML = KROWN.helpers.formatMoney(
              this.currentVariant.compare_at_price,
              KROWN.settings.shop_money_format
            )),
            (this.priceCompare.style.display = ""))
          : (this.priceCompare.style.display = "none"),
        this.priceUnit &&
          (this.currentVariant.unit_price_measurement
            ? (this.priceUnit.innerHTML = `\n${KROWN.helpers.formatMoney(
                this.currentVariant.unit_price,
                KROWN.settings.shop_money_format
              )} / \n${
                1 != this.currentVariant.unit_price_measurement.reference_value
                  ? this.currentVariant.unit_price_measurement.reference_value +
                    " "
                  : ""
              }\n${
                this.currentVariant.unit_price_measurement.reference_unit
              }\n`)
            : (this.priceUnit.innerHTML = "")))
      : ((this.priceOriginal.innerHTML = ""),
        (this.priceCompare.style.display = "none"),
        this.priceUnit && (this.priceUnit.innerHTML = ""));
  }
  updateStock() {
    if (this.currentVariant) {
      if (this.productStock && this.productStockData) {
        let e = !1;
        for (const t of this.productStockData)
          if (t.id == this.currentVariant.id) {
            e = t;
            break;
          }
        (this.productStock.innerHTML = ""),
          e &&
            (e.quantity <= 0
              ? "continue" == e.inventory
                ? ((this.productStock.innerHTML =
                    KROWN.settings.locales.products_preorder),
                  $(
                    ".product__cart-actions-holder .product__add-to-cart"
                  ).removeClass("no-cart"))
                : "deny" == e.inventory && e.quantity == 0 &&
                  ((this.productStock.innerHTML =
                    KROWN.settings.locales.products_no_products),
                  $(
                    ".product__cart-actions-holder .product__add-to-cart"
                  ).addClass("no-cart"))
              : "1" == e.quantity
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_one_product)
              : e.quantity <= 5
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    e.quantity
                  ))
              : e.unavailable
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products)
              : e.quantity > 5 &&
                "always" == this.productStock.dataset.type &&
                (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    e.quantity
                  )));
      }
    } else this.productStock && (this.productStock.innerHTML = "");
  }
  updateDetails() {
    this.productSKU &&
      (this.currentVariant.sku
        ? (this.productSKU.textContent =
            KROWN.settings.locales.product_sku + this.currentVariant.sku)
        : (this.productSKU.textContent = "")),
      this.productBARCODE &&
        (this.currentVariant.barcode
          ? (this.productBARCODE.textContent =
              KROWN.settings.locales.product_barcode +
              this.currentVariant.barcode)
          : (this.productBARCODE.textContent = ""));
  }
  updatePickupAvailability() {
    const e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  updateUnavailableVariants() {
    if ("true" == this.dataset.hideVariants) {
      let e = {},
        t = {},
        i = {},
        s = null,
        r = null;
      this.dataset.variants > 1 &&
        ((s = this._getSelectedOption(0)), this._resetDisabledOption(1)),
        this.dataset.variants > 2 &&
          ((r = this._getSelectedOption(1)), this._resetDisabledOption(2)),
        this.getVariantData().forEach((n) => {
          this.dataset.variants > 0 &&
            (e[n.option1] || (e[n.option1] = []),
            e[n.option1].push(String(n.available))),
            this.dataset.variants > 1 &&
              (t[n.option2] || (t[n.option2] = []),
              t[n.option2].push(String(n.available))),
            2 == this.dataset.variants &&
              (n.option1 != s ||
                n.available ||
                this._setDisabledOption(1, n.option2)),
            this.dataset.variants > 2 &&
              (i[n.option3] || (i[n.option3] = []),
              i[n.option3].push(String(n.available)),
              n.option2 != r ||
                n.option1 != s ||
                n.available ||
                this._setDisabledOption(2, n.option3));
        }),
        this.dataset.variants > 0 &&
          Object.keys(e).forEach((t) => {
            e[t].includes("true") ||
              this.querySelectorAll(".product-variant")[0]
                .querySelector(`.product-variant-value[value="${t}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 1 &&
          Object.keys(t).forEach((e) => {
            t[e].includes("true") ||
              this.querySelectorAll(".product-variant")[1]
                .querySelector(`.product-variant-value[value="${e}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 2 &&
          (Object.keys(i).forEach((e) => {
            i[e].includes("true") ||
              this.querySelectorAll(".product-variant")[2]
                .querySelector(`.product-variant-value[value="${e}"]`)
                .setAttribute("disabled", "disabled");
          }),
          Object.keys(t).forEach((e) => {
            t[e].includes("true") ||
              (r == e &&
                this.querySelectorAll(".product-variant")[2]
                  .querySelector(".product-variant-value")
                  .setAttribute("disabled", "disabled"));
          }));
    }
  }
  _getSelectedOption(e) {
    if ("select" == this.dataset.type)
      return this.querySelectorAll(".product-variant")[e].querySelector(
        ".product-variant-container"
      ).value;
    if ("radio" == this.dataset.type) {
      let t = null;
      return (
        this.querySelectorAll(".product-variant")
          [e].querySelectorAll(".product-variant__input")
          .forEach((e) => {
            e.checked && (t = e.value);
          }),
        t
      );
    }
  }
  _resetDisabledOption(e) {
    this.querySelectorAll(".product-variant")
      [e].querySelectorAll(".product-variant-value")
      .forEach((e) => {
        e.removeAttribute("disabled");
      });
  }
  _setDisabledOption(e, t) {
    this.querySelectorAll(".product-variant")
      [e].querySelector(`.product-variant-value[value="${t}"]`)
      .setAttribute("disabled", "disabled");
  }
  updateURL() {
    this.currentVariant &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    if (
      (this.currentVariant
        ? document
            .querySelector(".product__add-to-cart")
            .classList.remove("unavailable")
        : document.querySelector(".pre-orderproduct-btn") &&
          (document
            .querySelector(".product__add-to-cart")
            .classList.add("unavailable"),
          (this.addToCart.textContent =
            KROWN.settings.locales.products_unavailable_variant)),
      !this.currentVariant)
    )
    // FOR DPO APP
    if (
      (this.currentVariant
        ? document.querySelector(".product__add-to-cart[dpo_add2cart]")?.classList.remove("unavailable")
        : document.querySelector(".pre-orderproduct-btn") &&
          (document.querySelector(".product__add-to-cart[dpo_add2cart]")?.classList.add("unavailable"),
          (this.addToCart.textContent = KROWN.settings.locales.products_unavailable_variant)),
      !this.currentVariant)
    )
    return;
    document
      .querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      )
      .forEach((e) => {
        (e.querySelector('input[name="id"]').value = this.currentVariant.id),
          document.querySelector(".notify_me_button") &&
            document
              .querySelector(".notify_me_button")
              .setAttribute("data-variant-id", this.currentVariant.id);
      });
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("product-variants", ProductVariants);
class ProductForm extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.hasAttribute("data-ajax-cart") &&
      !document.body.classList.contains("template-cart") &&
      ((this.form = this.querySelector("form")),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.ADD_TO_CART = new Event("add-to-cart")));
  }
  onSubmitHandler(e) {
    e.preventDefault();
    var get_url =
      this.querySelector('[type="submit"]').getAttribute("data-url");
    const t = this.querySelector('[type="submit"]');
    t.classList.add("working");
    const i = serializeForm(this.form);
    let s = "";
    fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
      body: i,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "POST",
    })
      .then((e) => e.json())
      .then((e) =>
        422 == e.status
          ? ((s = document.createElement("span")),
            (s.className = "alert body-text-sm alert--error"),
            (s.innerHTML = e.description),
            fetch("?section_id=cart-helper"))
          : fetch("?section_id=cart-helper")
      )
      .then((e) => e.text())
      .then((e) => {
        const t = new DOMParser().parseFromString(e, "text/html"),
          i = t.getElementById("AjaxCartForm").innerHTML,
          r = t.getElementById("AjaxCartSubtotal").innerHTML,
          n = document.getElementById("AjaxCartForm");
        (n.innerHTML = i),
          n.ajaxifyCartItems(),
          "" != s &&
            document
              .getElementById("AjaxCartForm")
              .querySelector("form")
              .prepend(s),
          (document.getElementById("AjaxCartSubtotal").innerHTML = r),
          window.preloadImages(n),
          (document.querySelector("[data-header-cart-count]").textContent =
            document.querySelector(
              "#AjaxCartForm [data-cart-count]"
            ).textContent),
          this.dispatchEvent(this.ADD_TO_CART);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        t.classList.remove("working");
      });
  }
}
customElements.define("product-form", ProductForm);
class PickupAvailability extends HTMLElement {
  constructor() {
    super(),
      (this.errorHtml = this.querySelector(
        "template"
      ).content.firstElementChild.cloneNode(!0)),
      (this.onClickRefreshList = this.onClickRefreshList.bind(this)),
      this.hasAttribute("available") &&
        this.fetchAvailability(this.dataset.variantId);
  }
  fetchAvailability(e) {
    const t = `${this.dataset.baseUrl}variants/${e}/?section_id=pickup-availability`;
    fetch(t)
      .then((e) => e.text())
      .then((e) => {
        const t = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(t);
      })
      .catch((e) => {
        console.log(e),
          this.querySelector("button") &&
            this.querySelector("button").removeEventListener(
              "click",
              this.onClickRefreshList
            ),
          this.renderError();
      });
  }
  onClickRefreshList() {
    this.fetchAvailability(this.dataset.variantId);
  }
  renderError() {
    (this.innerHTML = ""),
      this.appendChild(this.errorHtml),
      this.querySelector("button").addEventListener(
        "click",
        this.onClickRefreshList
      );
  }
  renderPreview(e) {
    const t = document.getElementById("PickupAvailabilityDrawer");
    if ((t && t.remove(), !e.querySelector("pickup-availability-preview")))
      return (this.innerHTML = ""), void this.removeAttribute("available");
    (this.innerHTML = e.querySelector("pickup-availability-preview").outerHTML),
      this.setAttribute("available", ""),
      document.body.appendChild(e.querySelector("#PickupAvailabilityDrawer")),
      this.querySelector("button").addEventListener("click", (e) => {
        document.getElementById("PickupAvailabilityDrawer").show(e.target);
      }),
      this.querySelector("button").addEventListener("keyup", (e) => {
        e.keyCode == window.KEYCODES.RETURN &&
          document
            .getElementById("PickupAvailabilityDrawer")
            .querySelector("[data-close]")
            .focus();
      });
  }
}
customElements.define("pickup-availability", PickupAvailability);
class ProductImageZoom extends HTMLElement {
  constructor() {
    super(),
      document.getElementById("zoom")
        ? (this.zoom = document.getElementById("zoom"))
        : ((this.zoom = document.createElement("div")),
          (this.zoom.id = "zoom"),
          (this.zoom.innerHTML = `\n<img />\n<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>\n<div class="zoom__overlay"></div>\n`),
          document.body.append(this.zoom),
          this.zoom
            .querySelector(".zoom__exit")
            .addEventListener("click", this._productZoomUnmount.bind(this))),
      (this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this)),
      (this.onResizeHandlerBinded = this.onResizeHandler.bind(this)),
      this.addEventListener("click", (e) => {
        this.zoom.classList.add("opened"),
          (this.image = this.zoom.querySelector("img")),
          (this.image.src = this.getAttribute("data-image")),
          this.image.naturalWidth > 0
            ? this._productZoomMount()
            : this.image.addEventListener(
                "load",
                this._productZoomMount.bind(this)
              );
      });
  }
  onMouseMoveHandler(e) {
    (window.clientX = e.clientX), (window.clientY = e.clientY);
    const t =
        (e.clientX * (window.innerWidth - this.image.offsetWidth)) /
        window.innerWidth,
      i =
        (e.clientY * (window.innerHeight - this.image.offsetHeight)) /
        window.innerHeight;
    (this.image.style.left = t + "px"), (this.image.style.top = i + "px");
  }
  onResizeHandler() {
    const e = window.innerWidth > 768 ? 1 : 2;
    this.image.classList.contains("portrait")
      ? ((this.image.style.width = window.innerWidth * e + "px"),
        (this.image.style.height =
          (window.innerWidth * e) / this.image.dataset.ratio + "px"))
      : ((this.image.style.height = window.innerHeight * e + "px"),
        (this.image.style.width =
          window.innerHeight * e * this.image.dataset.ratio + "px"),
        this.image.offsetWidth < window.innerWidth &&
          ((this.image.style.width = window.innerWidth * e + "px"),
          (this.image.style.height =
            (window.innerWidth * e) / this.image.dataset.ratio + "px")));
    window.clientX,
      window.innerWidth,
      this.image.offsetWidth,
      window.innerWidth,
      window.clientY,
      window.innerHeight,
      this.image.offsetHeight,
      window.innerHeight;
  }
  _productZoomMount(e) {
    (this.image.style.left = 0),
      (this.image.style.top = 0),
      window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, {
        passive: !0,
      }),
      (this.image.dataset.ratio =
        this.image.naturalWidth / this.image.naturalHeight),
      window.addEventListener("resize", this.onResizeHandlerBinded, {
        passive: !0,
      }),
      this.onResizeHandler(),
      setTimeout(() => {
        (document.body.classList.contains("touch") ||
          document.body.classList.contains("touchevents")) &&
          ((this.zoom.scrollTop =
            (window.innerHeight - this.image.offsetHeight) / -2),
          (this.zoom.scrollLeft =
            (window.innerWidth - this.image.offsetWidth) / -2)),
          this.zoom.classList.add("loaded");
      }, 50);
  }
  _productZoomUnmount() {
    this.zoom.classList.remove("opened"),
      setTimeout(() => {
        window.removeEventListener("resize", this.onResizeHandlerBinded),
          window.removeEventListener(
            "mousemove",
            this.onMouseMoveHandlerBinded
          );
        const e = document.querySelector("#zoom img");
        (e.src = ""),
          (e.className = ""),
          (e.style = ""),
          this.zoom.classList.remove("loaded");
      }, 300);
  }
}
customElements.define("product-image-zoom", ProductImageZoom);
class SearchForm extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.cachedResults = {}),
      (this.input = this.querySelector("[data-search-input]")),
      (this.predictiveSearchResults = this.querySelector(
        "[data-search-results]"
      )),
      (this.results = []),
      (this.preloader = !1),
      "false" != KROWN.settings.predictive_search_enabled)
    ) {
      let e = this.input.value;
      this.input.addEventListener(
        "keyup",
        debounce((t) => {
          this.input.value != e
            ? ((e = this.input.value),
              this.getSearchResults(this.input.value.trim()))
            : "" == this.input.value && this.clearSearchResults();
        }, 150)
      ),
        this.input.addEventListener("keydown", (e) => {
          -1 != this.a11yIndex &&
            ((e.keyCode !== window.KEYCODES.UP &&
              e.keyCode !== window.KEYCODES.DOWN &&
              e.keyCode !== window.KEYCODES.RETURN) ||
              e.preventDefault());
        }),
        this.input.addEventListener("keyup", (e) =>
          e.keyCode === window.KEYCODES.UP
            ? (this.navigateThrough("UP"), !0)
            : e.keyCode === window.KEYCODES.DOWN
            ? (this.navigateThrough("DOWN"), !0)
            : void (
                e.keyCode === window.KEYCODES.RETURN &&
                -1 != this.a11yIndex &&
                (document.location.href =
                  this.results[this.a11yIndex].querySelector("a"))
              )
        );
    }
  }
  getSearchResults(e = "") {
    this.preloadSearchResults();
    const t = e.replace(" ", "-").toLowerCase();
    this.cachedResults[t]
      ? this.renderSearchResults(this.cachedResults[t])
      : ((this.a11yIndex = -1),
        fetch(
          `${
            KROWN.settings.routes.predictive_search_url
          }?q=${encodeURIComponent(e)}&resources[type]=${
            this.dataset.resourceType
          }&resources[limit]=4&section_id=predictive-search`
        )
          .then((e) => {
            if (!e.ok) {
              var t = new Error(e.status);
              throw (this.clearSearchResults(), t);
            }
            return e.text();
          })
          .then((e) => {
            const i = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            (this.cachedResults[t] = i), this.renderSearchResults(i);
          })
          .catch((e) => {
            throw e;
          }));
  }
  clearSearchResults() {
    (this.predictiveSearchResults.innerHTML = ""),
      (this.preloader = !1),
      (this.results = []);
  }
  preloadSearchResults() {
    this.preloader ||
      ((this.preloader = !0),
      (this.predictiveSearchResults.innerHTML =
        KROWN.settings.predictive_search_placeholder));
  }
  renderSearchResults(e) {
    (this.predictiveSearchResults.innerHTML = e),
      (this.preloader = !1),
      (this.results = this.predictiveSearchResults.querySelectorAll(
        ".search-item, .sidebar__search-link"
      )),
      window.preloadImages(this.predictiveSearchResults);
  }
  navigateThrough(e) {
    -1 == this.a11yIndex
      ? (this.a11yIndex = 0)
      : (this.results[this.a11yIndex].classList.remove("active"),
        "UP" == e
          ? this.a11yIndex - 1 >= -1 && this.a11yIndex--
          : "DOWN" == e &&
            this.a11yIndex + 1 < this.results.length &&
            this.a11yIndex++),
      this.a11yIndex >= 0
        ? (this.results[this.a11yIndex].classList.add("active"),
          (document.getElementById("site-search-sidebar").scrollTop =
            this.results[this.a11yIndex].offsetTop - 200))
        : (document.getElementById("site-search-sidebar").scrollTop = 0);
  }
}
customElements.define("search-form", SearchForm);
class ToggleTab extends HTMLElement {
  constructor() {
    super(),
      (this.titleEl = this.querySelector(".toggle__title")),
      (this.contentEl = this.querySelector(".toggle__content")),
      (this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`),
      this.titleEl.addEventListener("click", this.onClickHandler.bind(this)),
      this.titleEl.addEventListener("keydown", (e) => {
        e.keyCode == window.KEYCODES.RETURN && this.onClickHandler();
      });
  }
  onClickHandler() {
    this.titleEl.classList.contains("opened")
      ? (this.titleEl.classList.remove("opened"),
        this.titleEl.setAttribute("aria-expanded", "false"),
        this.slideUp(this.contentEl, 200))
      : (this.titleEl.classList.add("opened"),
        this.titleEl.setAttribute("aria-expanded", "true"),
        this.slideDown(this.contentEl, 200));
  }
  slideUp(e, t) {
    (e.style.transitionProperty = "height, margin, padding"),
      (e.style.transitionDuration = t + "ms"),
      (e.style.boxSizing = "border-box"),
      (e.style.height = e.offsetHeight + "px"),
      e.offsetHeight,
      (e.style.overflow = "hidden"),
      (e.style.height = 0),
      (e.style.paddingTop = 0),
      (e.style.paddingBottom = 0),
      (e.style.marginTop = 0),
      (e.style.marginBottom = 0),
      setTimeout(() => {
        (e.style.display = "none"),
          e.style.removeProperty("height"),
          e.style.removeProperty("padding-top"),
          e.style.removeProperty("padding-bottom"),
          e.style.removeProperty("margin-top"),
          e.style.removeProperty("margin-bottom"),
          e.style.removeProperty("overflow"),
          e.style.removeProperty("transition-duration"),
          e.style.removeProperty("transition-property");
      }, t);
  }
  slideDown(e, t) {
    e.style.removeProperty("display");
    var i = window.getComputedStyle(e).display;
    "none" === i && (i = "block"), (e.style.display = i);
    var s = e.offsetHeight;
    (e.style.overflow = "hidden"),
      (e.style.height = 0),
      (e.style.paddingTop = 0),
      (e.style.paddingBottom = 0),
      (e.style.marginTop = 0),
      (e.style.marginBottom = 0),
      e.offsetHeight,
      (e.style.boxSizing = "border-box"),
      (e.style.transitionProperty = "height, margin, padding"),
      (e.style.transitionDuration = t + "ms"),
      (e.style.height = s + "px"),
      e.style.removeProperty("padding-top"),
      e.style.removeProperty("padding-bottom"),
      e.style.removeProperty("margin-top"),
      e.style.removeProperty("margin-bottom"),
      setTimeout(() => {
        e.style.removeProperty("height"),
          e.style.removeProperty("overflow"),
          e.style.removeProperty("transition-duration"),
          e.style.removeProperty("transition-property");
      }, t);
  }
}
customElements.define("toggle-tab", ToggleTab),
  document.addEventListener("shopify:block:select", (e) => {
    const t = e.target;
    t.classList.contains("toggle") &&
      (t.querySelector(".toggle__title").classList.contains("opened") ||
        t.onClickHandler());
  }),
  document.addEventListener("shopify:block:deselect", (e) => {
    const t = e.target;
    t.classList.contains("toggle") &&
      t.querySelector(".toggle__title").classList.contains("opened") &&
      t.onClickHandler();
  });
class VideoPopup extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".video-popup__link").addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          const t = document.createElement("div");
          t.classList.add("video-popup__blackout"),
            this.append(t),
            setTimeout(() => {
              t.style.opacity = "1";
            }, 10),
            this.classList.add("video-opened"),
            this.querySelector(".video-popup__close") &&
              this.querySelector(".video-popup__close").addEventListener(
                "click",
                (e) => {
                  this.querySelectorAll("iframe, video").forEach((e) => {
                    e.remove();
                  }),
                    this.querySelector(".video-popup__blackout").remove(),
                    this.classList.remove("video-opened");
                }
              ),
            setTimeout(() => {
              pauseAllMedia(),
                this.querySelector(".video-popup__container").appendChild(
                  this.querySelector(
                    "template"
                  ).content.firstElementChild.cloneNode(!0)
                ),
                setTimeout(() => {
                  playMedia(this.closest("[data-video]"));
                }, 500);
            }, 50);
        }
      );
  }
}
customElements.define("video-popup", VideoPopup);
class VideoBackground extends HTMLElement {
  constructor() {
    super();
    let e = !1,
      t = document.createElement("video");
    t.setAttribute("playsinline", "playsinline"),
      t.setAttribute("muted", "muted"),
      t.setAttribute("autoplay", "autoplay"),
      t.setAttribute("loop", "loop"),
      t.setAttribute("controls", "controls"),
      t.setAttribute("width", 20),
      t.setAttribute("height", 20),
      (t.onplay = () => {
        e = !0;
      }),
      t.setAttribute(
        "src",
        "data:video/mp4;base64,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"
      ),
      (t.style.position = "fixed"),
      (t.style.top = "-20px"),
      (t.style.left = "0px"),
      (t.style.zIndex = "997"),
      document.querySelector("body").appendChild(t);
    let i = t.play();
    void 0 !== i &&
      i
        .then(() => {
          this.autoPlayCallback(!0), t.remove();
        })
        .catch((i) => {
          e || i.toString().includes("interact with the document")
            ? this.autoPlayCallback(!0)
            : this.autoPlayCallback(!1),
            t.remove();
        });
  }
  autoPlayCallback(e) {
    if (e) {
      const e = this.querySelector(".video-text__background");
      e &&
        ((e.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${e.dataset.src}"></video>`),
        e.querySelector("video").play(),
        setTimeout(() => {
          e.querySelector("video").style.opacity = "1";
        }, 200));
    } else
      this.querySelector(
        ".video-text__background .video-text__image"
      ).style.display = "block";
  }
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
customElements.define("video-background", VideoBackground),
  (KROWN.helpers = {
    formatMoney: function (e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      let i = "";
      const s = /\{\{\s*(\w+)\s*\}\}/,
        r = t || moneyFormat;
      function n(e, t, i, s) {
        if (((i = i || ","), (s = s || "."), isNaN(e) || null === e)) return 0;
        const r = (e = (e / 100).toFixed(t)).split(".");
        return (
          r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (r[1] ? s + r[1] : "")
        );
      }
      switch (r.match(s)[1]) {
        case "amount":
          i = n(e, 2);
          break;
        case "amount_no_decimals":
          i = n(e, 0);
          break;
        case "amount_with_comma_separator":
          i = n(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          i = n(e, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          i = n(e, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          i = n(e, 2, "'");
      }
      return r.replace(s, i);
    },
  });
const getPseudoContent = (e) => {
    var t = document.querySelector(e);
    return window.getComputedStyle(t, ":after").getPropertyValue("content");
  },
  pauseAllMedia = () => {
    document.querySelectorAll(".product .js-youtube").forEach((e) => {
      e.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }),
      document.querySelectorAll(".product .js-vimeo").forEach((e) => {
        e.contentWindow.postMessage('{"method":"pause"}', "*");
      }),
      document.querySelectorAll(".product video").forEach((e) => e.pause()),
      document.querySelectorAll(".product product-model").forEach((e) => {
        e.modelViewerUI && e.modelViewerUI.pause();
      });
  },
  playMedia = (e) => {
    switch (e.dataset.productMediaType) {
      case "video":
        e.querySelector("video").play();
        break;
      case "external_video-youtube":
        e.querySelector(".js-youtube").contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
        break;
      case "external_video-vimeo":
        e.querySelector(".js-vimeo").contentWindow.postMessage(
          '{"method":"play"}',
          "*"
        );
    }
  },
  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */ serializeForm = (e) => {
    let t = [];
    return (
      Array.prototype.slice.call(e.elements).forEach(function (e) {
        !e.name ||
          e.disabled ||
          ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
          ("select-multiple" !== e.type
            ? (["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked) ||
              t.push(
                encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)
              )
            : Array.prototype.slice.call(e.options).forEach(function (i) {
                i.selected &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(i.value)
                  );
              }));
      }),
      t.join("&")
    );
  },
  getJSONP = (e, t) => {
    var s = "_" + +new Date(),
      o = document.createElement("script"),
      a = document.getElementsByTagName("head")[0] || document.documentElement;
    (window[i] = function (e) {
      r.removeChild(s), t && t(e);
    }),
      (s.src = e.replace("callback=?", "callback=" + i)),
      r.appendChild(s);
  },
  trueTypeOf = (e) =>
    Object.prototype.toString.call(e).slice(8, -1).toLowerCase(),
  htmlEscape = (e) =>
    e
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;"),
  reframe = (e, t) => {
    let i = "string" == typeof e ? document.querySelectorAll(e) : e;
    const s = t || "js-reframe";
    "length" in i || (i = [i]);
    for (let e = 0; e < i.length; e += 1) {
      const t = i[e];
      if (
        -1 !== t.className.split(" ").indexOf(s) ||
        t.style.width.indexOf("%") > -1
      )
        continue;
      const r =
          ((t.getAttribute("height") || t.offsetHeight) /
            (t.getAttribute("width") || t.offsetWidth)) *
          100,
        n = document.createElement("div");
      n.className = s;
      const o = n.style;
      (o.position = "relative"), (o.width = "100%"), (o.paddingTop = `${r}%`);
      const a = t.style;
      (a.position = "absolute"),
        (a.width = "100%"),
        (a.height = "100%"),
        (a.left = "0"),
        (a.top = "0"),
        t.parentNode.insertBefore(n, t),
        t.parentNode.removeChild(t),
        n.appendChild(t);
    }
  };
(window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13,
}),
  (function (e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : (("undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : this
        ).basicLightbox = e());
  })(function () {
    return (function e(t, i, s) {
      function r(o, a) {
        if (!i[o]) {
          if (!t[o]) {
            var l = "function" == typeof require && require;
            if (!a && l) return l(o, !0);
            if (n) return n(o, !0);
            var c = new Error("Cannot find module '" + o + "'");
            throw ((c.code = "MODULE_NOT_FOUND"), c);
          }
          var d = (i[o] = { exports: {} });
          t[o][0].call(
            d.exports,
            function (e) {
              return r(t[o][1][e] || e);
            },
            d,
            d.exports,
            e,
            t,
            i,
            s
          );
        }
        return i[o].exports;
      }
      for (
        var n = "function" == typeof require && require, o = 0;
        o < s.length;
        o++
      )
        r(s[o]);
      return r;
    })(
      {
        1: [
          function (e, t, i) {
            "use strict";
            Object.defineProperty(i, "__esModule", { value: !0 }),
              (i.create = i.visible = void 0);
            var s = function (e) {
                var t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  i = document.createElement("div");
                return (
                  (i.innerHTML = e.trim()), !0 === t ? i.children : i.firstChild
                );
              },
              r = function (e, t) {
                var i = e.children;
                return 1 === i.length && i[0].tagName === t;
              },
              n = function (e) {
                return (
                  null != (e = e || document.querySelector(".basicLightbox")) &&
                  !0 === e.ownerDocument.body.contains(e)
                );
              };
            (i.visible = n),
              (i.create = function (e, t) {
                var i = (function (e, t) {
                    var i = s(
                        '\n\t\t<div class="basicLightbox '.concat(
                          t.className,
                          '">\n\t\t\t<div class="basicLightbox__placeholder" role="dialog"></div>\n\t\t</div>\n\t'
                        )
                      ),
                      n = i.querySelector(".basicLightbox__placeholder");
                    e.forEach(function (e) {
                      return n.appendChild(e);
                    });
                    var o = r(n, "IMG"),
                      a = r(n, "VIDEO"),
                      l = r(n, "IFRAME");
                    return (
                      !0 === o && i.classList.add("basicLightbox--img"),
                      !0 === a && i.classList.add("basicLightbox--video"),
                      !0 === l && i.classList.add("basicLightbox--iframe"),
                      i
                    );
                  })(
                    (e = (function (e) {
                      var t = "string" == typeof e,
                        i = e instanceof HTMLElement == 1;
                      if (!1 === t && !1 === i)
                        throw new Error(
                          "Content must be a DOM element/node or string"
                        );
                      return !0 === t
                        ? Array.from(s(e, !0))
                        : "TEMPLATE" === e.tagName
                        ? [e.content.cloneNode(!0)]
                        : Array.from(e.children);
                    })(e)),
                    (t = (function () {
                      var e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : {};
                      if (
                        (null == (e = Object.assign({}, e)).closable &&
                          (e.closable = !0),
                        null == e.className && (e.className = ""),
                        null == e.onShow && (e.onShow = function () {}),
                        null == e.onClose && (e.onClose = function () {}),
                        "boolean" != typeof e.closable)
                      )
                        throw new Error(
                          "Property `closable` must be a boolean"
                        );
                      if ("string" != typeof e.className)
                        throw new Error(
                          "Property `className` must be a string"
                        );
                      if ("function" != typeof e.onShow)
                        throw new Error("Property `onShow` must be a function");
                      if ("function" != typeof e.onClose)
                        throw new Error(
                          "Property `onClose` must be a function"
                        );
                      return e;
                    })(t))
                  ),
                  o = function (e) {
                    return (
                      !1 !== t.onClose(a) &&
                      (function (e, t) {
                        return (
                          e.classList.remove("basicLightbox--visible"),
                          setTimeout(function () {
                            return (
                              !1 === n(e) || e.parentElement.removeChild(e), t()
                            );
                          }, 410),
                          !0
                        );
                      })(i, function () {
                        if ("function" == typeof e) return e(a);
                      })
                    );
                  };
                !0 === t.closable &&
                  i.addEventListener("click", function (e) {
                    e.target === i && o();
                  });
                var a = {
                  element: function () {
                    return i;
                  },
                  visible: function () {
                    return n(i);
                  },
                  show: function (e) {
                    return (
                      !1 !== t.onShow(a) &&
                      (function (e, t) {
                        return (
                          document.body.appendChild(e),
                          setTimeout(function () {
                            requestAnimationFrame(function () {
                              return (
                                e.classList.add("basicLightbox--visible"), t()
                              );
                            });
                          }, 10),
                          !0
                        );
                      })(i, function () {
                        if ("function" == typeof e) return e(a);
                      })
                    );
                  },
                  close: o,
                };
                return a;
              });
          },
          {},
        ],
      },
      {},
      [1]
    )(1);
  });
class CSSSlider extends HTMLElement {
  constructor() {
    super();
    const e = navigator.userAgent.toLowerCase();
    (this._ios15 =
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch)) &&
      e.includes("applewebkit") &&
      (e.includes("os 15_") || e.includes("version/15"))),
      this.initSlider();
  }
  destroySlider() {
    this.classList.remove("enabled"),
      (this.sliderEnabled = !1),
      window.removeEventListener("resize", this.RESIZE_EVENT),
      window.preloadImages(this);
  }
  initSlider() {
    (this._readyEvent = new CustomEvent("ready")),
      (this._changeEvent = new CustomEvent("change")),
      (this._scrollEvent = new CustomEvent("scroll")),
      (this._navEvent = new CustomEvent("navigation")),
      (this._pointerDownEvent = new CustomEvent("pointerDown")),
      (this._pointerUpEvent = new CustomEvent("pointerUp")),
      window.preloadImages(this),
      (this.items = this.querySelectorAll(".css-slide[data-index]")),
      (this.indexedItems = []),
      (this.index = 0),
      (this.length = this.items.length),
      (this.windowWidth = window.innerWidth),
      (this.scrollLeft = 0),
      this.length > 1
        ? ((this.navigation = document.createElement("div")),
          (this.navigation.classList = `css-slider-navigation ${this.getAttribute(
            "data-navigation-class"
          )}`),
          (this.navigation.style.display = "none"),
          (this.navigation.innerHTML = `<div>\n<span class="css-slider-navigation__index">0</span> / <span class="css-slider-navigation__length">0</span>\n</div>\n<button class="css-slider-navigation__prev simple-arrow simple-arrow--left disabled">\n<span class="visually-hidden">${KROWN.settings.locales.prev}</span>\n${KROWN.settings.symbols.arrow}\n</button>\n<button class="css-slider-navigation__next simple-arrow simple-arrow--right">\n<span class="visually-hidden">${KROWN.settings.locales.next}</span>\n${KROWN.settings.symbols.arrow}\n</button>`),
          this.classList.contains("css-slider--auto-height")
            ? this.parentNode.parentNode.insertBefore(
                this.navigation,
                this.parentNode.nextSibling
              )
            : this.parentNode.insertBefore(this.navigation, this.nextSibling),
          (this.indexEl = this.navigation.querySelector(
            ".css-slider-navigation__index"
          )),
          (this.lengthEl = this.navigation.querySelector(
            ".css-slider-navigation__length"
          )),
          (this.prevEl = this.navigation.querySelector(
            ".css-slider-navigation__prev"
          )),
          (this.nextEl = this.navigation.querySelector(
            ".css-slider-navigation__next"
          )),
          this.prevEl.addEventListener("click", (e) => {
            this.changeSlide("prev");
          }),
          this.nextEl.addEventListener("click", (e) => {
            this.changeSlide("next");
          }),
          this.classList.contains("css-slider--auto-height") &&
            (this.parentNode.style.height = this.items[0].offsetHeight + "px"),
          (this.OBSERVER = new IntersectionObserver(
            (e) => {
              e.forEach((e) => {
                e.intersectionRatio >= 0.5 &&
                  ((this.index = parseInt(e.target.getAttribute("data-index"))),
                  this.checkSlide());
              });
            },
            { threshold: [0, 0.5] }
          )),
          (this.RESIZE_EVENT = debounce(() => {
            this.windowWidth != window.innerWidth && this.resetSlider(),
              (this.windowWidth = window.innerWidth);
          }, 100)),
          window.addEventListener("resize", this.RESIZE_EVENT),
          this.resetSlider(!0),
          "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch) ||
            (this.addEventListener("mousedown", (e) => {
              (this.mouseX = e.screenX),
                this.classList.add("can-drag"),
                this.classList.add("mouse-down");
            }),
            this.addEventListener("mouseup", (e) => {
              this.classList.remove("mouse-down"),
                this.classList.remove("can-drag"),
                this.classList.remove("pointer-events-off");
            }),
            this.addEventListener("mouseleave", (e) => {
              this.classList.remove("mouse-down"),
                this.classList.remove("can-drag"),
                this.classList.remove("pointer-events-off");
            }),
            this.addEventListener("mousemove", (e) => {
              if (this.classList.contains("can-drag")) {
                this.classList.add("pointer-events-off");
                let t = this.mouseX - e.screenX;
                Math.abs(t) > 1 &&
                  (t > 0
                    ? (this.changeSlide("next"),
                      this.classList.remove("can-drag"))
                    : t < 0 &&
                      (this.changeSlide("prev"),
                      this.classList.remove("can-drag")));
              }
            })))
        : 1 == this.length
        ? this.classList.add("css-slider--singular")
        : this.classList.add("css-slider--empty"),
      this.classList.add("enabled"),
      (this.sliderEnabled = !0),
      this.dispatchEvent(this._readyEvent);
  }
  changeSlide(e, t = "smooth") {
    "next" == e
      ? this.index + 1 < this.length && this.index++
      : this.index - 1 >= 0 && this.index--,
      this.checkSlide(),
      this._ios15 && this.classList.add("disable-snapping"),
      setTimeout(() => {
        this._ios15 && this.classList.remove("disable-snapping");
      }, 500),
      this.scrollTo({
        top: 0,
        left:
          this.indexedItems[this.index].offsetLeft -
          parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
        behavior: t,
      }),
      this.dispatchEvent(this._changeEvent);
  }
  checkSlide() {
    this.prevEl.classList.remove("disabled"),
      this.nextEl.classList.remove("disabled"),
      0 == this.index && this.prevEl.classList.add("disabled"),
      this.index == this.length - 1 && this.nextEl.classList.add("disabled"),
      (this.indexEl.innerHTML = this.index + 1),
      this.classList.contains("css-slider--auto-height") &&
        (this.parentNode.style.height =
          this.indexedItems[this.index].offsetHeight + "px");
  }
  afterAppend() {
    this.items = this.querySelectorAll(".css-slide[data-index]");
  }
  resetSlider(e = !1, t = !0) {
    let i = 0,
      s = 0,
      r = 0,
      n = this.classList.contains("css-slider--auto-height")
        ? window.innerWidth
        : this.querySelector(".css-slides-container").offsetWidth - 20,
      o = !1;
    (this.indexedItems = []),
      this.OBSERVER.disconnect(),
      this.classList.add("disable-snapping"),
      this.items.forEach((e, t) => {
        e.classList.remove("css-slide--snap"),
          (i += e.offsetWidth),
          i > n && 0 == s && (s = t);
      }),
      0 == s && ((s = this.items.length), (o = !0)),
      this.items.forEach((e, t) => {
        t % s == 0 &&
          (e.classList.add("css-slide--snap"),
          e.setAttribute("data-index", r++),
          this.OBSERVER.observe(e));
      }),
      (this.indexedItems = this.querySelectorAll(".css-slide--snap")),
      t && (this.index = 0),
      (this.length = Math.ceil(this.items.length / s)),
      (this.lengthEl.innerHTML = this.length),
      (this.indexEl.innerHTML = 1),
      o
        ? ((this.navigation.style.display = "none"),
          this.classList.add("css-slider--no-drag"))
        : ((this.navigation.style.display = "block"),
          this.classList.remove("css-slider--no-drag")),
      e || this.scrollTo({ top: 0, left: 0, behavior: "auto" }),
      this.classList.remove("disable-snapping");
  }
}
customElements.define("css-slider", CSSSlider);
class MainHeader extends HTMLElement {
  constructor() {
    super(), this.mount();
  }
  mount() {
    const e = document.getElementById("site-cart-sidebar");
    document.getElementById("cart-open-button") &&
      (document
        .getElementById("cart-open-button")
        .addEventListener("click", (t) => {
          t.preventDefault(),
            document
              .getElementById("cart-open-button")
              .setAttribute("aria-expanded", "true"),
            e.show();
        }),
      document
        .getElementById("cart-open-button")
        .addEventListener("keyup", (t) => {
          t.keyCode == window.KEYCODES.RETURN &&
            e.querySelector(".close-sidebar").focus();
        }));
    const t = document.getElementById("site-menu-sidebar");
    document.getElementById("menu-open-button") &&
      (document
        .getElementById("menu-open-button")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            document
              .getElementById("menu-open-button")
              .setAttribute("aria-expanded", "true"),
            t.show();
        }),
      document
        .getElementById("menu-open-button")
        .addEventListener("keyup", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            t.querySelector(".close-sidebar").focus();
        }));
    const i = document.getElementById("site-search-sidebar");
    document.getElementById("search-open-button") &&
      document.getElementById("search-open-button").addEventListener(
        "click",
        function (e) {
          e.preventDefault(),
            document
              .getElementById("search-open-button")
              .setAttribute("aria-expanded", "true"),
            i.show(),
            setTimeout(() => {
              i.querySelector("[data-search-input]").focus();
            }, 10);
        }.bind(this)
      );
    document
      .querySelectorAll('span[id^="product-open-button-"]')
      .forEach((e) => {
        e &&
          (e.addEventListener("click", (t) => {
            t.preventDefault(), e.setAttribute("aria-expanded", "true");
            var i = e.getAttribute("data-sidebar_index");
            // console.log(i, "eeeeeee");
            document
              .querySelector('sidebar-drawer[data-index="' + i + '"]')
              .show();
          }),
          e.addEventListener("keyup", (e) => {
            e.keyCode == window.KEYCODES.RETURN &&
              sidebarProduct.querySelector(".close-sidebar").focus();
          }));
      }),
      document
        .querySelectorAll(".sidebar__close button.close-sidebar")
        .forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(),
              e.target
                .closest(".sidebar")
                .classList.contains("sidebar--opened") &&
                e.target.closest(".sidebar").hide();
          });
        }),
      document.querySelector(".page-overlay").addEventListener("click", (e) => {
        document.querySelector(".sidebar--opened") &&
          document.querySelector(".sidebar--opened").hide();
      }),
      document.addEventListener("keydown", (e) => {
        e.keyCode == window.KEYCODES.ESC &&
          document.querySelector(".sidebar--opened") &&
          document.querySelector(".sidebar--opened").hide();
      }),
      (this.RESIZE_SidebarHelper = debounce(() => {
        document.querySelector(".sidebar--opened") &&
          (document.querySelector(".sidebar--opened").style.height =
            window.innerHeight + "px");
      }, 200)),
      window.addEventListener("resize", this.RESIZE_SidebarHelper);
    const s = document.querySelector(".header-holder");
    (window.lst = window.scrollY),
      (window.lhp = 0),
      (this.SCROLL_StickyHelper = () => {
        var e = window.scrollY;
        e < 0 ||
          Math.abs(lst - e) <= 5 ||
          (e <= window.lhp || 0 == e
            ? (s.classList.remove("animate"),
              s.classList.remove("fix"),
              s.classList.remove("ready"))
            : e <= lst && !s.classList.contains("fix")
            ? ((window.lhp = s.querySelector(".header").offsetTop),
              s.classList.add("fix"),
              setTimeout(() => {
                s.classList.add("ready");
              }, 5),
              setTimeout(() => {
                s.classList.add("animate");
              }, 25))
            : e > lst &&
              s.classList.contains("animate") &&
              (s.classList.remove("animate"),
              setTimeout(() => {
                s.classList.remove("fix"), s.classList.remove("ready");
              }, 105)),
          (window.lst = e));
      }),
      window.addEventListener("scroll", this.SCROLL_StickyHelper, {
        passive: !0,
      });
    let r = 0,
      n = document.querySelector(".sidebar__menus"),
      o = document.querySelector("#site-menu-sidebar button.close-sidebar"),
      a = document.querySelector("#site-menu-sidebar button.navigate-back");
    document
      .querySelectorAll(".sidebar__menus .sidebar__menu .has-submenu > a")
      .forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault(),
            (n.scrollTop = 0),
            (r = e.target.parentElement.classList.contains("has-second-submenu")
              ? 2
              : 1),
            e.target.parentElement.classList.add("opened"),
            e.target.closest(".sidebar__menus").classList.add("opened"),
            e.target.parentElement.parentElement.classList.add("opened"),
            e.target.parentElement.parentElement.parentElement.classList.add(
              "opened"
            ),
            (o.style.display = "none"),
            (a.style.display = "flex");
        }),
          e.addEventListener("keydown", (i) => {
            if (i.keyCode == window.KEYCODES.RETURN) {
              t._unmountA11YHelper();
              let i = [a];
              e.parentElement.querySelectorAll("a").forEach((e) => {
                i.push(e);
              }),
                t._mountA11YHelper(i),
                setTimeout(() => {
                  a.focus();
                }, 10);
            }
          });
      }),
      document
        .querySelector(".sidebar__close button.navigate-back")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            1 == r
              ? ((r = 0),
                n.classList.remove("opened"),
                n.querySelectorAll(".opened").forEach((e) => {
                  e.classList.remove("opened");
                }),
                (n.scrollTop = 0),
                (a.style.display = "none"),
                (o.style.display = "flex"))
              : 2 == r &&
                ((r = 1),
                n
                  .querySelector(".has-second-submenu.opened")
                  .parentElement.classList.remove("opened"),
                n
                  .querySelector(".has-second-submenu.opened")
                  .parentElement.parentElement.classList.remove("opened"),
                n
                  .querySelector(".has-second-submenu.opened")
                  .classList.remove("opened"));
        }),
      document
        .querySelector(".sidebar__close button.navigate-back")
        .addEventListener("keydown", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            1 == r &&
            (t._unmountA11YHelper(),
            setTimeout(() => {
              o.focus(), t._mountA11YHelper();
            }, 10));
        });
  }
  unmount() {
    window.removeEventListener("resize", this.RESIZE_SidebarHelper),
      window.removeEventListener("scroll", this.SCROLL_StickyHelper);
  }
}
customElements.define("main-header", MainHeader);
class SidebarDrawer extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".close-sidebar").addEventListener("click", () => {
        this.hide();
      }),
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          const e = document.querySelector("sidebar-drawer.sidebar--opened");
          e && e.hide();
        }
      });
  }
  show() {
    var e = document.getElementsByTagName("html")[0];
    (this.opened = !0), document.body.classList.add("sidebar-opened");
    var t = !1;
    $("#site-product-sidebar").length > 0 && (t = !0),
      this.classList.contains("sidebar--right")
        ? (document.body.classList.add("sidebar-opened--right"),
          t && e.classList.add("pro_var_popup_open"))
        : this.classList.contains("sidebar--left") &&
          document.body.classList.add("sidebar-opened--left"),
      (this.style.display = "block"),
      setTimeout(() => {
        this.classList.add("sidebar--opened"),
          (this.style.height = window.innerHeight + "px"),
          this._mountA11YHelper();
      }, 15);
  }
  hide() {
    var e = document.getElementsByTagName("html")[0];
    (this.opened = !1), this.classList.remove("sidebar--opened");
    $("#site-product-sidebar").length,
      document.body.classList.remove("sidebar-opened"),
      document.body.classList.remove("sidebar-opened--left"),
      document.body.classList.remove("sidebar-opened--right"),
      e.classList.remove("pro_var_popup_open"),
      this._unmountA11YHelper();
    const t = document.querySelectorAll('span[id^="product-open-button-"]');
    "site-cart-sidebar" == this.id
      ? document
          .getElementById("cart-open-button")
          .setAttribute("aria-expanded", "false")
      : "site-search-sidebar" == this.id
      ? document
          .getElementById("search-open-button")
          .setAttribute("aria-expanded", "false")
      : "site-menu-sidebar" == this.id
      ? document
          .getElementById("menu-open-button")
          .setAttribute("aria-expanded", "false")
      : t.forEach((e) => {
          this.id == e && e.setAttribute("aria-expanded", "false");
        }),
      setTimeout(() => {
        this.style.display = "none";
      }, 501);
  }
  _mountA11YHelper(e) {
    let t =
        e ||
        this.querySelectorAll(
          '[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover'
        ),
      i = t[0],
      s = t[t.length - 1];
    "site-cart-sidebar" == this.id &&
      "0" != this.querySelector(".cart-holder").getAttribute("data-items") &&
      (s = t[t.length - 2]),
      (this.A11Y_TAB_EVENT = ((e, t, i) => {
        ("Tab" === i.key || i.keyCode === window.KEYCODES.TAB) &&
          (i.shiftKey
            ? document.activeElement === e && (t.focus(), i.preventDefault())
            : document.activeElement === t && (e.focus(), i.preventDefault()));
      }).bind(this, i, s)),
      this.addEventListener("keydown", this.A11Y_TAB_EVENT);
  }
  _unmountA11YHelper() {
    this.removeEventListener("keydown", this.A11Y_TAB_EVENT);
  }
}
customElements.define("sidebar-drawer", SidebarDrawer);
class ProductModel extends HTMLElement {
  constructor() {
    super(),
      Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
  }
  setupModelViewerUI(e) {
    if (e) return;
    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );
    const t = this.modelViewerUI.viewer;
    t.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
      t.closest(".product-gallery") &&
        t.closest(".product-gallery").toggleDragging(!1);
    }),
      t.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
        t.closest(".product-gallery") &&
          t.closest(".product-gallery").toggleDragging(!0);
      }),
      t.closest(".product-gallery__item") &&
        "0" == t.closest(".product-gallery__item").dataset.index &&
        t.closest(".product-gallery") &&
        t.closest(".product-gallery").toggleDragging(!1);
  }
}
customElements.define("product-model", ProductModel),
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      e ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((e) => {
              window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  });
class CollectionFiltersMobileHandle extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("button").addEventListener("click", () => {
        document.getElementById("site-filters-sidebar").show();
      });
  }
}
customElements.define(
  "collection-filters-mobile-handle",
  CollectionFiltersMobileHandle
);
class ProductPage extends HTMLElement {
  constructor() {
    super(),
      (this.productGallery = this.querySelector(".product-gallery")),
      this.querySelector(".product__quantity") &&
        this.querySelector(".product__quantity").addEventListener(
          "click",
          (e) => {
            e.target.select();
          }
        );
    const e = this.querySelector("product-variants");
    if (
      (e &&
        (e.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this)
        ),
        this.onVariantChangeHandler({ target: e })),
        this.querySelector(".product__add-to-cart") && this.querySelector(".product__cart-actions-holder")
      )
    ) {
      const e = this.querySelector(".product__cart-actions-holder");
      new MutationObserver((t, i) => {
        for (const i of t)
          "class" == i.attributeName &&
            (e.classList.remove("disabled"),
            e.classList.remove("working"),
            i.target.classList.contains("disabled") &&
              e.classList.add("disabled"),
            i.target.classList.contains("working") &&
              e.classList.add("working"));
      }).observe(this.querySelector(".product__add-to-cart"), {
        attributes: !0,
        childList: !1,
        subtree: !1,
      }),
      this.querySelector(".product__add-to-cart").classList.contains("disabled") && e.classList.add("disabled");
    }
    if (
      (this.productGallery.addEventListener("change", (e) => {
        "model" ==
          this.productGallery.items[this.productGallery.index].dataset
            .productMediaType &&
          (setTimeout(() => {
            this.productGallery.toggleDragging(!1);
          }, 15),
          this.xrButton &&
            this.xrButton.setAttribute(
              "data-shopify-model3d-id",
              this.productGallery.items[this.productGallery.index].dataset
                .mediaId
            )),
          pauseAllMedia();
      }),
      !this.classList.contains("featured-product"))
    ) {
      const e = this.querySelector(".product__offers > div");
      (this._EVENT_SCROLL = (t) => {
        if (window.innerHeight < e.offsetHeight) {
          let t = this.getBoundingClientRect().y,
            i = e.offsetHeight - window.innerHeight;
          Math.abs(t) < i
            ? (e.style.top = `${t}px`)
            : Math.abs(t) >= i && (e.style.top = -i + "px");
        }
      }),
        window.addEventListener("scroll", this._EVENT_SCROLL, { passive: !0 }),
        (this.style.minHeight = `${e.offsetHeight}px`),
        setInterval(() => {
          this.style.minHeight = `${e.offsetHeight}px`;
        }, 500);
    }
    if (
      !document.body.classList.contains("template-cart") &&
      "overlay" == KROWN.settings.cart_action
    ) {
      let e = !1;
      this.querySelector(".product__add-to-cart") &&
        this.querySelector(".product__add-to-cart").addEventListener(
          "keyup",
          (t) => {
            t.keyCode == window.KEYCODES.RETURN && (e = !0);
          }
        ),
        this.querySelector(".product__form") &&
          this.querySelector(".product__form").addEventListener(
            "add-to-cart",
            () => {
              window.preloadImages(
                document.getElementById("site-cart-sidebar")
              ),
                document.getElementById("site-cart-sidebar").show(),
                e &&
                  setTimeout(() => {
                    document
                      .querySelector("#site-cart-sidebar .close-sidebar")
                      .focus();
                  }, 200);
            }
          );
    }
    this.querySelectorAll("product-model") &&
      (window.ProductModel.loadShopifyXR(),
      (this.xrButton = this.querySelector(".product-gallery__view-in-space")));
  }
  onVariantChangeHandler(e) {
    let t = e.target.currentVariant;
    if (t && null != t.featured_media) {
      let e = this.productGallery.querySelector(
        '.product-gallery__item[data-media-id="' + t.featured_media.id + '"]'
      );
      e &&
        (this.productGallery.classList.contains("js-enabled")
          ? this.productGallery.changeSlide(parseInt(e.dataset.index))
          : (this.productGallery.dataset.initialIndex = e.dataset.index));
    }
  }
}
customElements.define("product-page", ProductPage);
class ProductSlider extends HTMLElement {
  constructor() {
    super();
    const e = navigator.userAgent.toLowerCase();
    (this._ios15 =
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch)) &&
      e.includes("applewebkit") &&
      (e.includes("os 15_") || e.includes("version/15"))),
      this.classList.add("js-enabled"),
      (this.viewport = this.querySelector(".product-gallery__viewport")),
      (this.container = this.querySelector(".product-gallery__container")),
      (this.holder = this.querySelector(".product-gallery__items")),
      (this.items = this.querySelectorAll(".product-gallery__item")),
      (this.index = this.dataset.initialIndex
        ? parseInt(this.dataset.initialIndex)
        : 0),
      (this.length = this.items.length),
      (this.timeout = null),
      (this.animating = !1),
      (this._mobilePadding = parseInt(
        window
          .getComputedStyle(document.documentElement)
          .getPropertyValue("--grid-padding")
      )),
      (this.changeSlide = (e) => {
        if (this.mobile)
          this._iOS15snapping(),
            this.holder.scrollTo({
              left:
                this.items[e].offsetLeft -
                parseInt(getComputedStyle(this.items[e]).marginLeft),
              top: 0,
              behavior: "smooth",
            }),
            this._checkNav(e),
            this._checkIndex(!0),
            this._setHeight();
        else if (
          (this._blockAnimation(!0), this._resetClasses(), e > this.index)
        ) {
          let t = this.index;
          (this.index = e - 1),
            this.holder.classList.add("no-transitions"),
            this._resetClasses(),
            this._resetOrder([t, this.index]),
            (this.holder.style.transform = `translateX(${
              this.index * this.width * -1
            }px`),
            this.items[t].classList.add("active"),
            this.items[e].classList.add("after-active"),
            this._checkNav(e),
            setTimeout(() => {
              this.holder.classList.remove("no-transitions"),
                this.items[t].classList.remove("active"),
                this.items[t].classList.add("before-active"),
                (this.holder.style.transform = `translateX(${
                  e * this.width * -1
                }px`),
                this.items[e].classList.remove("after-active"),
                this.items[e].classList.add("active"),
                (this.index = e),
                this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);
        } else if (e < this.index) {
          let t = this.index;
          (this.index = e + 1),
            this.holder.classList.add("no-transitions"),
            this._resetClasses(),
            this._resetOrder([t, this.index]),
            (this.holder.style.transform = `translateX(${
              this.index * this.width * -1
            }px`),
            this.items[t].classList.add("active"),
            this.items[e].classList.add("before-active"),
            this._checkNav(e),
            setTimeout(() => {
              this.holder.classList.remove("no-transitions"),
                this.items[t].classList.remove("active"),
                this.items[t].classList.add("after-active"),
                (this.holder.style.transform = `translateX(${
                  e * this.width * -1
                }px`),
                this.items[e].classList.remove("before-active"),
                this.items[e].classList.add("active"),
                (this.index = e),
                this.dispatchEvent(this.EVENT_CHANGE);
            }, 10);
        }
        this._setHeight(e);
      }),
      (this.toggleDragging = (e) => {
        e
          ? this.container.classList.remove("force-no-drag")
          : this.container.classList.add("force-no-drag");
      }),
      (this.EVENT_CHANGE = new Event("change")),
      (this.EVENT_SETTLE = new Event("settle"));
    const t = document.createElement("div");
    const message = window.sliderText != null ? '\n<p class="slider_message">'+ window.sliderText +'</p>' : '';
    t.setAttribute(
      "class",
      "product-gallery__navigation five-tenths lap--six-tenths smaller-lap--eleven-tenths push-left-one-tenth lap--push-left-none smaller-lap--push-left-padding"
    ),
      (t.innerHTML = `\n<div class="product-gallery__no">\n  <span class="product-gallery__index">${
        this.index + 1
      }</span> / ${
        this.length
      }\n</div>`+ message +`\n<button class="product-gallery__prev simple-arrow simple-arrow--left">\n  <span class="visually-hidden">${
        KROWN.settings.locales.prev
      }</span>\n  ${
        KROWN.settings.symbols.arrow
      }\n</button>\n<button class="product-gallery__next simple-arrow simple-arrow--right">\n  <span class="visually-hidden">${
        KROWN.settings.locales.next
      }</span>\n  ${KROWN.settings.symbols.arrow}\n</button>`),
      this.appendChild(t),
      (this.indexEl = this.querySelector(".product-gallery__index")),
      (this.prevEl = this.querySelector(".product-gallery__prev")),
      (this.nextEl = this.querySelector(".product-gallery__next")),
      this.prevEl.addEventListener("click", () => {
        this.prevSlide(), playMedia(this.items[this.index]);
      }),
      this.nextEl.addEventListener("click", () => {
        this.nextSlide(), playMedia(this.items[this.index]);
      }),
      this.addEventListener("keydown", (e) => {
        "37" == e.keyCode &&
          (this.prevSlide(), playMedia(this.items[this.index])),
          "39" == e.keyCode &&
            (this.nextSlide(), playMedia(this.items[this.index]));
      }),
      this.querySelectorAll(
        ".product-gallery__prev, .product-gallery__next"
      ).forEach((e) => {
        e.addEventListener("keydown", (e) => {
          e.keyCode == window.KEYCODES.RETURN &&
            ((window.scrollY = this.container.offsetTop - 100),
            setTimeout(() => {
              this.items[this.index].focus();
            }, 50));
        });
      }),
      this.container.addEventListener(
        "touchstart",
        (e) => {
          this.mobile ||
            this.container.classList.contains("force-no-drag") ||
            ((this.touchX = e.touches[0].screenX),
            this.container.classList.add("dragging-enabled"));
        },
        { passive: !0 }
      ),
      this.container.addEventListener(
        "touchmove",
        (e) => {
          if (
            !this.mobile &&
            this.container.classList.contains("dragging-enabled") &&
            !this.container.classList.contains("force-no-drag")
          ) {
            let t = this.touchX - e.touches[0].screenX;
            t > 0
              ? (this.nextSlide(),
                this.container.classList.remove("dragging-enabled"))
              : t < 0 &&
                (this.prevSlide(),
                this.container.classList.remove("dragging-enabled"));
          }
        },
        { passive: !0 }
      ),
      this.container.addEventListener(
        "touchend",
        (e) => {
          this.mobile || this.container.classList.remove("dragging-enabled");
        },
        { passive: !0 }
      ),
      this.container.addEventListener("mousedown", (e) => {
        this.mobile ||
          this.container.classList.contains("force-no-drag") ||
          ((this.mouseX = e.screenX),
          this.container.classList.add("dragging-enabled"),
          this.container.classList.add("mouse-down"));
      }),
      this.container.addEventListener("mouseup", (e) => {
        this.mobile ||
          (this.container.classList.remove("mouse-down"),
          this.container.classList.remove("pointer-events-off"),
          this.container.classList.remove("dragging-enabled"));
      }),
      this.container.addEventListener("mousemove", (e) => {
        if (
          !this.mobile &&
          this.container.classList.contains("dragging-enabled") &&
          !this.container.classList.contains("force-no-drag")
        ) {
          let t = this.mouseX - e.screenX;
          Math.abs(t) > 1 &&
            (this.container.classList.add("pointer-events-off"),
            t > 0
              ? (this.nextSlide(),
                this.container.classList.remove("dragging-enabled"))
              : t < 0 &&
                (this.prevSlide(),
                this.container.classList.remove("dragging-enabled")));
        }
      }),
      (this.OBSERVER = new IntersectionObserver(
        (e) => {
          this.mobile &&
            e.forEach((e) => {
              e.intersectionRatio >= 0.3 &&
                ((this.index = parseInt(e.target.getAttribute("data-index"))),
                this._checkNav(),
                this._checkIndex(!0),
                this._setHeight(),
                this.dispatchEvent(this.EVENT_CHANGE));
            });
        },
        { threshold: [0, 0.3] }
      )),
      this.items.forEach((e) => {
        this.OBSERVER.observe(e);
      }),
      this._checkMobile(),
      this._resetOrder(),
      this._checkIndex(),
      this._checkNav(),
      this._setHeight(),
      this._getSliderWidth(),
      setTimeout(() => {
        this._getSliderWidth();
      }, 500),
      this._repositionSlider(),
      (this.EVENT_RESIZE = () => {
        this._checkMobile(),
          this._setHeight(),
          this._getSliderWidth(),
          this._repositionSlider(),
          (this._mobilePadding = parseInt(
            window
              .getComputedStyle(document.documentElement)
              .getPropertyValue("--grid-padding")
          ));
      }),
      window.addEventListener("resize", this.EVENT_RESIZE),
      this.items[this.index].classList.add("enable-tab"),
      this.items[this.index].setAttribute("tabindex", "0"),
      this.mobile &&
        (this.holder.scrollLeft = this.items[this.index].offsetLeft);
  }
  _checkMobile() {
    -1 != getComputedStyle(this, ":after").content.indexOf("mobile-enabled")
      ? (this.mobile = !0)
      : (this.mobile = !1);
  }
  _checkIndex(e = !1) {
    e && this._resetClasses(),
      this.items[this.index].classList.add("active"),
      this.items[this.index].setAttribute("tabindex", "0"),
      this.items[this.index + 1] &&
        (this.items[this.index + 1].classList.add("after-active"),
        this.items[this.index + 1].setAttribute("tabindex", "-1")),
      this.items[this.index - 1] &&
        (this.items[this.index - 1].classList.add("before-active"),
        this.items[this.index - 1].setAttribute("tabindex", "-1")),
      e || (this.indexEl.innerHTML = this.index + 1);
  }
  _checkNav(e = null) {
    let t = null != e ? e : this.index;
    this.nextEl.classList.remove("active"),
      this.nextEl.classList.remove("disabled"),
      this.prevEl.classList.remove("disabled"),
      this.nextEl.removeAttribute("disabled"),
      this.prevEl.removeAttribute("disabled"),
      (this.indexEl.innerHTML = t + 1);
  }
  _getSliderWidth() {
    this.width = this.items[0].getBoundingClientRect().width;
  }
  _repositionSlider() {
    this.holder.classList.add("no-transitions"),
      (this.holder.style.transform = `translateX(${
        this.index * this.width * -1
      }px`),
      setTimeout(() => {
        this.holder.classList.remove("no-transitions");
      }, 10);
  }
  _resetClasses() {
    this.items.forEach((e) => {
      e.classList.remove("before-active"),
        e.classList.remove("after-active"),
        e.classList.remove("active");
    });
  }
  _resetOrder(e = null) {
    this.items.forEach((t, i) => {
      let s = i;
      null != e && (i == e[0] ? (s = e[1]) : i == e[1] && (s = e[0])),
        (t.style.order = s);
    });
  }
  _translateSlider() {
    (this.holder.style.transform = `translateX(${
      this.index * this.width * -1
    }px`),
      this._checkIndex(),
      this._checkNav();
  }
  _blockAnimation(e = !1) {
    (this.animating = !0),
      (this.timeout = setTimeout(() => {
        (this.animating = !1),
          this.dispatchEvent(this.EVENT_SETTLE),
          e && (this._resetOrder(), this._resetClasses(), this._checkIndex());
      }, 500));
  }
  _setHeight(e = null, t = !0) {
    let i = null != e ? e : this.index;
    t || this.viewport.classList.add("no-transition"),
      this.items[i].querySelector(".lazy-image") &&
        (this.viewport.style.height = `${
          this.items[i].querySelector(".lazy-image").offsetHeight
        }px`),
      t ||
        setTimeout(() => {
          this.viewport.classList.remove("no-transition");
        }, 20);
  }
  _iOS15snapping() {
    this._ios15 && this.holder.classList.add("disable-snapping"),
      setTimeout(() => {
        this._ios15 && this.holder.classList.remove("disable-snapping");
      }, 500);
  }
  nextSlide() {
    this.mobile
      ? (this.index + 1 < this.length ? this.index++ : (this.index = 0),
        this._iOS15snapping(),
        this.holder.scrollTo({
          left:
            this.items[this.index].offsetLeft -
            parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: "smooth",
        }),
        this._setHeight(),
        this._checkNav(),
        this._checkIndex(!0))
      : this.animating ||
        (this._blockAnimation(),
        this._resetClasses(),
        this.index + 1 < this.length ? this.index++ : (this.index = 0),
        this._checkIndex(),
        this._checkNav(),
        this._setHeight(),
        this._translateSlider(),
        this.dispatchEvent(this.EVENT_CHANGE));
  }
  prevSlide() {
    this.mobile
      ? (this.index - 1 >= 0 ? this.index-- : (this.index = this.length - 1),
        this._iOS15snapping(),
        this.holder.scrollTo({
          left:
            this.items[this.index].offsetLeft -
            parseInt(getComputedStyle(this.items[this.index]).marginLeft),
          top: 0,
          behavior: "smooth",
        }),
        this._setHeight(),
        this._checkNav(),
        this._checkIndex(!0))
      : this.animating ||
        (this._blockAnimation(),
        this._resetClasses(),
        this.index - 1 >= 0 ? this.index-- : (this.index = this.length - 1),
        this._checkIndex(),
        this._checkNav(),
        this._setHeight(),
        this._translateSlider(),
        this.dispatchEvent(this.EVENT_CHANGE));
  }
}
customElements.define("product-slider", ProductSlider);
class ProductReviews {
  constructor(e) {
    const t = new MutationObserver((e, t) => {
      for (const i of e)
        i.addedNodes.length > 0 &&
          i.addedNodes.forEach((e) => {
            "DIV" == e.tagName &&
              e.classList.contains("spr-container") &&
              (this.init(e), t.disconnect());
          });
    });
    e.querySelector(".spr-review")
      ? this.init(e.querySelector(".spr-container"))
      : t.observe(e, { childList: !0 });
  }
  init(e) {
    if (e.querySelector(".spr-review")) {
      const t = document.querySelector(".product__price-reviews .rating-text");
      document
        .querySelector("#shopify-product-reviews .spr-summary-starrating")
        .prepend(
          this.createRatingEl(
            document.querySelector(".spr-summary-starrating"),
            "spr-custom-rating",
            t ? t.textContent : ""
          )
        );
      const i = e.querySelector(".spr-reviews");
      i.querySelectorAll(".spr-review").forEach((e, t) => {
        (e.classList = `spr-review css-slide three-tenths lap--smart-width palm--smart-width ${
          0 == t ? "push-left-one-tenth" : "push-left-half-tenth"
        } palm--push-left-padding`),
          (e.dataset.index = 99);
      });
      const s = document.createElement("div");
      (s.innerHTML = `<css-slider\nclass="css-slider css-slider--snapping" \ndata-navigation-class="ten-tenths lap--twelve-tenths push-left-one-tenth lap--push-left-padding"\n>\n<div class="spr-reviews css-slides-container">\n${i.innerHTML}\n</div>\n</div>`),
        s.querySelectorAll(".spr-review").forEach((e) => {
          this.initReview(e);
        }),
        i.remove(),
        e.querySelector(".spr-content").append(s),
        e.querySelector(".spr-summary-actions").classList.add("with-reviews"),
        e.append(e.querySelector(".spr-summary-actions"));
      const r = s.querySelector("css-slider");
      setTimeout(() => {
        r.resetSlider(!0);
      }, 100);
      const n = new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            if (
              e.isIntersecting &&
              e.target.querySelector(".spr-pagination-next a")
            ) {
              const l = e.target.querySelector(".spr-pagination-next a");
              (t = `${SPR.api_url}/reviews?page=${l.dataset.page}&product_id=${l.dataset.productId}&shop=${window.location.hostname}&callback=?`),
                (i = (e) => {
                  l.closest(".spr-pagination").remove();
                  const t = new DOMParser().parseFromString(
                    e.reviews,
                    "text/html"
                  );
                  t.querySelectorAll(".spr-review, .spr-pagination") &&
                    t
                      .querySelectorAll(".spr-review, .spr-pagination")
                      .forEach((e) => {
                        e.classList.contains("spr-review") &&
                          ((e.classList =
                            "spr-review css-slide three-tenths lap--smart-width palm--smart-width push-left-half-tenth palm--push-left-padding"),
                          (e.dataset.index = 99)),
                          r.querySelector(".css-slides-container").append(e),
                          e.classList.contains("spr-pagination")
                            ? (n.disconnect(), n.observe(e))
                            : this.initReview(e);
                      }),
                    r.afterAppend(),
                    r.resetSlider(!0, !1);
                }),
                (s = "_" + +new Date()),
                (o = document.createElement("script")),
                (a =
                  document.getElementsByTagName("head")[0] ||
                  document.documentElement),
                (window[s] = function (e) {
                  a.removeChild(o), i && i(e);
                }),
                (o.src = t.replace("callback=?", "callback=" + s)),
                a.appendChild(o);
            }
            var t, i, s, o, a;
          });
        },
        { threshold: 1 }
      );
      s.querySelector(".spr-pagination") &&
        n.observe(s.querySelector(".spr-pagination"));
    }
    const t = document.createElement("div");
    (t.id = "spr-form-modal"),
      (t.innerHTML =
        '<div id="spr-form" class="spr-form-holder address-popup">\n<div class="basicLightboxClose">×</div>\n</div>');
    const i = basicLightbox.create(t);
    document
      .querySelector(".spr-summary-actions-newreview")
      .setAttribute("onclick", ""),
      document
        .querySelector(".spr-summary-actions-newreview")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            i.show(() => {
              i.element().querySelector(".basicLightboxClose") &&
                i
                  .element()
                  .querySelector(".basicLightboxClose")
                  .addEventListener("click", () => {
                    i.close();
                  });
            });
        }),
      i
        .element()
        .querySelector(".spr-form-holder")
        .prepend(e.querySelector(".spr-form")),
      (i.element().querySelector(".spr-form").style.display = "block"),
      (e.querySelector(".spr-summary-actions-newreview").innerHTML = `\n${
        KROWN.settings.symbols.plus
      }\n<span>${
        e.querySelector(".spr-summary-actions-newreview").innerHTML
      }</span>`);
  }
  initReview(e) {
    e
      .querySelector(".spr-review-header")
      .insertBefore(
        this.createRatingEl(e, "spr-review-custom-rating"),
        e.querySelector(".spr-review-header").firstElementChild.nextSibling
      ),
      e.insertBefore(
        e.querySelector(".spr-review-header-byline"),
        e.querySelector(".spr-review-footer")
      );
    let t = e.querySelector(".spr-review-content-body").textContent;
    if (wordFunctions.count(t) > 30) {
      let i = basicLightbox.create(
        `<div class="spr-review-modal">\n<div class="spr-review-header">${
          e.querySelector(".spr-review-header").innerHTML
        }</div>\n${
          e.querySelector(".spr-review-content-body").innerHTML
        }\n<span class="spr-review-header-byline">${
          e.querySelector(".spr-review-header-byline").innerHTML
        }</span>\n</div>`
      );
      e.querySelector(".spr-review-content-body").textContent =
        wordFunctions.trim(t, 30);
      const s = document.createElement("span");
      (s.classList = "spr-review-read-more"),
        (s.textContent = KROWN.settings.locales.product_read_review),
        e.querySelector(".spr-review-content").append(s),
        s.addEventListener("click", () => {
          i.show();
        });
    }
  }
  createRatingEl(e, t, i = "") {
    const s = e.querySelectorAll(".spr-icon-star").length,
      r = e.querySelectorAll(".spr-icon-star-half-alt").length > 0 ? ".5" : "",
      n = document.createElement("span");
    return (
      (n.classList = `${t} text-size--regular`),
      (n.innerHTML = `<span>${"" != i ? i : `${s + r} / 5`}</span>${
        KROWN.settings.symbols.star
      }`),
      n
    );
  }
}
document.getElementById("shopify-product-reviews") &&
  new ProductReviews(document.getElementById("shopify-product-reviews"));
const wordFunctions = {
  count: function (e) {
    return e.match(/(\w+)/g).length;
  },
  trim: function (e, t) {
    const i = e.trim().split(" "),
      s = i.length > t ? "..." : "";
    return i.slice(0, t).join(" ") + s;
  },
};
class CollectionListItem extends HTMLElement {
  constructor() {
    super(),
      setTimeout(() => {
        this.querySelector(".collection-list-item-image").style.visibility =
          "visible";
      }, 200),
      this.addEventListener(
        "mousemove",
        (e) => {
          const t = this.querySelector(".collection-list-item-image");
          (t.style.top = e.clientY - this.getBoundingClientRect().top + "px"),
            (t.style.left =
              e.clientX - this.getBoundingClientRect().left + "px");
        },
        { passive: !0 }
      );
  }
}
customElements.define("collection-list-item", CollectionListItem);
class SliderVertical extends HTMLElement {
  constructor() {
    super(), this.UNMOUNT(), this.MOUNT();
  }
  MOUNT() {
    this.querySelectorAll("video").forEach((e) => {
      e.playing || 2 == e.readyState
        ? e.classList.add("loaded")
        : (e.addEventListener("canplay", (t) => {
            e.classList.add("loaded");
          }),
          setTimeout(
            ((e) => {
              if (e.paused) {
                e.closest(".slide-image").querySelector("img");
                e.remove();
              }
            }).bind(this, e),
            3e3
          ));
    }),
      (this.headingsHolder = this.querySelector(".vertical-slider-headings")),
      this.querySelectorAll(".slide-heading").forEach((e) => {
        const t = e.cloneNode(!0);
        this.headingsHolder.appendChild(t);
      }),
      (this.headings = this.querySelectorAll(
        ".vertical-slider-headings .slide-heading"
      )),
      (this.OBSERVER_A = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_A_function(e);
          });
        },
        { threshold: [0.05, 0.6] }
      )),
      (this.OBSERVER_B = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_B_function(e);
          });
        },
        { threshold: [0.05, 0.7] }
      )),
      (this.OBSERVER_MAIN = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_MAIN_function(e);
          });
        },
        { threshold: 0 }
      )),
      (this.OBSERVER_NEXT = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            this._observer_NEXT_function(e);
          });
        },
        { threshold: 0 }
      )),
      (this.slides = this.querySelectorAll(".slide")),
      this.slides.forEach((e) => {
        if (
          ("true" === e.dataset.first
            ? (this.OBSERVER_A.observe(e),
              "true" === e.dataset.last && this.OBSERVER_B.observe(e))
            : this.OBSERVER_B.observe(e),
          e.hasAttribute("data-link"))
        ) {
          const t = document.createElement("a");
          (t.className = "slide-heading"),
            t.setAttribute("href", e.querySelector("a").getAttribute("href")),
            e.querySelector(".slide-title") &&
              t.appendChild(e.querySelector(".slide-title")),
            e.querySelector(".slide-caption") &&
              t.appendChild(e.querySelector(".slide-caption")),
            e.querySelector(".slide-heading").append(t);
        }
      }),
      this.OBSERVER_MAIN.observe(this.parentNode),
      setTimeout(() => {
        if (this.parentNode.nextElementSibling)
          this.OBSERVER_NEXT.observe(this.parentNode.nextElementSibling);
        else {
          const e = document.querySelector(".page-content").nextElementSibling;
          0 == e.children.length && (e = e.nextElementSibling),
            this.OBSERVER_NEXT.observe(e);
        }
        if (!this.parentNode.previousSibling) {
          const e = this.querySelectorAll(
            ".vertical-slider-headings .slide-heading"
          )[0];
          e.classList.add("never-remove"),
            Math.abs(this.parentNode.getBoundingClientRect().y) <
              window.innerHeight &&
              (e.classList.add("active-up"), (e.style.display = "flex"));
        }
      }, 25),
      (this.RESIZE_EVENT = debounce(() => {
        this._resizeCaptions();
      }, 100)),
      window.addEventListener("resize", this.RESIZE_EVENT),
      this._resizeCaptions();
  }
  _observer_A_function(e) {
    const t = this.headings[e.target.dataset.index];
    "true" === e.target.dataset.first &&
      (!e.target.classList.contains("active") && e.intersectionRatio >= 0.6
        ? (this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
          e.target.classList.add("active"),
          this._resetHeadingClasses(),
          (t.style.display = "flex"),
          e.boundingClientRect.top > 0
            ? t.classList.add("active-up")
            : t.classList.add("active-down"))
        : !e.target.classList.contains("active") &&
          e.intersectionRatio >= 0.05 &&
          e.intersectionRatio < 0.6
        ? (this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
          e.target.classList.add("active"),
          this._resetHeadingClasses(),
          (t.style.display = "flex"),
          t.classList.add("active-down"))
        : !t.classList.contains("never-remove") &&
          e.target.classList.contains("active") &&
          e.intersectionRatio < 0.6 &&
          e.boundingClientRect.top > 0 &&
          (e.target.classList.remove("active"),
          t.classList.remove("active-up"),
          t.classList.remove("active-down"),
          t.classList.add("hide-up")));
  }
  _observer_B_function(e) {
    const t = this.headings[e.target.dataset.index];
    e.intersectionRatio > 0.05 &&
      !e.target.classList.contains("active") &&
      "true" !== e.target.dataset.first &&
      (("true" === e.target.dataset.last && e.boundingClientRect.top < 0) ||
        (this.querySelector(".slide.active") &&
          this.querySelector(".slide.active").classList.remove("active"),
        e.target.classList.add("active"),
        this._resetHeadingClasses(),
        (t.style.display = "flex"),
        e.boundingClientRect.top > 0
          ? t.classList.add("active-up")
          : t.classList.add("active-down")));
  }
  _observer_MAIN_function(e) {
    0 == e.intersectionRatio &&
      (this.querySelector(".slide.active") &&
        this.querySelector(".slide.active").classList.remove("active"),
      this.querySelectorAll(".active-up").forEach((e) => {
        e.classList.remove("active-up");
      }),
      this.querySelectorAll(".active-down").forEach((e) => {
        e.classList.remove("active-down");
      }),
      this.querySelectorAll(".slide-heading").forEach((e) => {
        e.style.display = "none";
      }));
  }
  _observer_NEXT_function(e) {
    if (e.intersectionRatio > 0)
      this.slides[this.slides.length - 1].classList.contains("active") &&
        setTimeout(() => {
          this.querySelector(".slide.active") &&
            this.querySelector(".slide.active").classList.remove("active"),
            this.querySelectorAll(".active-up").forEach((e) => {
              e.classList.remove("active-up");
            }),
            this.querySelectorAll(".active-down").forEach((e) => {
              e.classList.remove("active-down");
            }),
            this.headings[this.headings.length - 1].classList.add("hide-down");
        }, 20);
    else if (
      0 == e.intersectionRatio &&
      e.boundingClientRect.top > 0 &&
      !this.querySelector(".slide.active")
    ) {
      let e = this.parentNode.getBoundingClientRect();
      if (e.y < 0 && Math.abs(e.y) < e.height) {
        this.slides[this.slides.length - 1].classList.add("active");
        let e = this.headings[this.headings.length - 1];
        e.classList.remove("hide-down"),
          e.classList.remove("hide-up"),
          (e.style.display = "flex"),
          e.classList.add("active-up");
      }
    }
  }
  _resetHeadingClasses() {
    this.headingsHolder
      .querySelectorAll(".active-up, .active-down, .hide-down, .hide-up")
      .forEach((e) => {
        (e.style.display = "none"),
          e.classList.remove("active-up"),
          e.classList.remove("active-down"),
          e.classList.remove("hide-down"),
          e.classList.remove("hide-up");
      });
  }
  _resizeCaptions() {
    this.slides.forEach((e) => {
      e.querySelectorAll(".slide-image[data-caption]").forEach(function (e) {
        e.querySelector(".slide-image__caption").style.width =
          e.offsetHeight - 10 + "px";
      });
    });
  }
  initVideo(e) {
    e.classList.add("loaded");
  }
  UNMOUNT() {
    this.OBSERVER_A && this.OBSERVER_A.disconnect(),
      this.OBSERVER_B && this.OBSERVER_B.disconnect(),
      this.OBSERVER_MAIN && this.OBSERVER_MAIN.disconnect(),
      this.OBSERVER_NEXT && this.OBSERVER_NEXT.disconnect(),
      window.removeEventListener("resize", this.RESIZE_EVENT);
  }
}
customElements.define("vertical-slider", SliderVertical),
  Object.defineProperty(HTMLMediaElement.prototype, "playing", {
    get: function () {
      return !!(
        this.currentTime > 0 &&
        !this.paused &&
        !this.ended &&
        this.readyState > 2
      );
    },
  }),
  (KROWN.themeName = "Highlight"),
  (KROWN.themeVersion = "2.0.4");
const executeOnceOnDomContentLoaded = () => {
  reframe(
    document.querySelectorAll(
      '.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]'
    )
  ),
    document
      .querySelectorAll(
        ".css-slider, .product-variant__input, .simple-arrow, .mount-header [tabindex]"
      )
      .forEach((e) => {
        e.addEventListener("blur", (e) => {
          e.currentTarget.classList.remove("focus");
        });
      });
  let e = document.activeElement;
  document.addEventListener("keyup", (t) => {
    t.keyCode == window.KEYCODES.TAB &&
      (e.classList.contains("focus") &&
        t.target != e &&
        e.classList.remove("focus"),
      (t.target.classList.contains("css-slider") ||
        t.target.classList.contains("product-variant__input") ||
        t.target.classList.contains("simple-arrow") ||
        "-1" != t.target.getAttribute("tabindex")) &&
        t.target.classList.add("focus"),
      (e = document.activeElement));
  }),
    "?customer_posted=true" == window.location.search
      ? setTimeout(() => {
          window.scroll({
            top: document.querySelector("form .alert").offsetTop - 250,
            behavior: "smooth",
          });
        }, 300)
      : window.location.pathname.includes("/challenge") &&
        setTimeout(() => {
          window.scroll({ top: 0, behavior: "auto" });
        }, 300),
    document.querySelectorAll(".rte a img").forEach((e) => {
      e.parentNode.style.border = "none";
    });
};
"loading" !== document.readyState
  ? executeOnceOnDomContentLoaded()
  : document.addEventListener(
      "DOMContentLoaded",
      executeOnceOnDomContentLoaded
    );